import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  BigInt: { input: number; output: number; }
  BigUInt: { input: number; output: number; }
  Map: { input: any; output: any; }
  RolloutStatus: { input: number; output: number; }
  Time: { input: any; output: any; }
  Version: { input: number; output: number; }
};

export type ApiKey = {
  __typename?: 'APIKey';
  createdAt: Scalars['Time']['output'];
  id: Scalars['String']['output'];
};

export type Account = {
  __typename?: 'Account';
  metadata: Metadata;
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  documentation: Array<DocumentationLink>;
  message: Scalars['String']['output'];
};

export type Agent = {
  __typename?: 'Agent';
  architecture?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<AgentConfiguration>;
  configurationResource?: Maybe<Configuration>;
  configurationStatus: ConfigurationVersions;
  connectedAt?: Maybe<Scalars['Time']['output']>;
  disconnectedAt?: Maybe<Scalars['Time']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  features: Scalars['Int']['output'];
  home?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labels?: Maybe<Scalars['Map']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operatingSystem?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  remoteAddress?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  upgrade?: Maybe<AgentUpgrade>;
  upgradeAvailable?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AgentConfiguration = {
  __typename?: 'AgentConfiguration';
  Collector?: Maybe<Scalars['String']['output']>;
  Logging?: Maybe<Scalars['String']['output']>;
  Manager?: Maybe<Scalars['Map']['output']>;
};

export type AgentMonitoringSummary = {
  __typename?: 'AgentMonitoringSummary';
  connected: Scalars['Int']['output'];
  disconnected: Scalars['Int']['output'];
  errored: Scalars['Int']['output'];
  outdated: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgentSelector = {
  __typename?: 'AgentSelector';
  matchLabels?: Maybe<Scalars['Map']['output']>;
};

export type AgentUpgrade = {
  __typename?: 'AgentUpgrade';
  error?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type Agents = {
  __typename?: 'Agents';
  agents: Array<Agent>;
  latestVersion: Scalars['String']['output'];
  query?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Suggestion>>;
};

export type AgentsTable = {
  __typename?: 'AgentsTable';
  agentCount: Scalars['Int']['output'];
  agentMetrics: Array<GraphMetric>;
  agents: Array<Agent>;
  latestVersion: Scalars['String']['output'];
  query: Scalars['String']['output'];
  suggestions: Array<Suggestion>;
};

export type AgentsTableOptions = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  selector?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type AuditEvent = {
  __typename?: 'AuditEvent';
  account?: Maybe<Scalars['String']['output']>;
  action?: Maybe<AuditEventAction>;
  configuration?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  resourceKind: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Time']['output']>;
  user: Scalars['String']['output'];
};

export enum AuditEventAction {
  Created = 'created',
  Deleted = 'deleted',
  Modified = 'modified',
  Paused = 'paused',
  Pending = 'pending',
  Resumed = 'resumed',
  Started = 'started',
  Unknown = 'unknown'
}

export type AuditEventFilter = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['Time']['input']>;
  minDate?: InputMaybe<Scalars['Time']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthType {
  ActiveDirectory = 'activeDirectory',
  Basic = 'basic',
  Google = 'google',
  Ldap = 'ldap'
}

export type ChangeAccountInput = {
  accountId: Scalars['String']['input'];
};

export type ClearAgentUpgradeErrorInput = {
  agentId: Scalars['String']['input'];
};

export type Configuration = {
  __typename?: 'Configuration';
  activeTypes?: Maybe<Array<Scalars['String']['output']>>;
  agentCount?: Maybe<Scalars['Int']['output']>;
  apiVersion: Scalars['String']['output'];
  graph?: Maybe<Graph>;
  kind: Scalars['String']['output'];
  metadata: Metadata;
  rendered?: Maybe<Scalars['String']['output']>;
  spec: ConfigurationSpec;
  status: ConfigurationStatus;
};

export type ConfigurationChange = {
  __typename?: 'ConfigurationChange';
  configuration: Configuration;
  eventType: EventType;
};

export type ConfigurationMonitoringSummary = {
  __typename?: 'ConfigurationMonitoringSummary';
  errored: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConfigurationSpec = {
  __typename?: 'ConfigurationSpec';
  contentType?: Maybe<Scalars['String']['output']>;
  destinations?: Maybe<Array<ResourceConfiguration>>;
  extensions?: Maybe<Array<ResourceConfiguration>>;
  measurementInterval?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  selector?: Maybe<AgentSelector>;
  sources?: Maybe<Array<ResourceConfiguration>>;
};

export type ConfigurationStatus = {
  __typename?: 'ConfigurationStatus';
  current: Scalars['Boolean']['output'];
  currentVersion: Scalars['Version']['output'];
  latest: Scalars['Boolean']['output'];
  pending: Scalars['Boolean']['output'];
  rollout: Rollout;
};

export type ConfigurationSummary = {
  __typename?: 'ConfigurationSummary';
  dataset: Array<SummaryGraphDataPoint>;
  name: Scalars['String']['output'];
  totalEgress: Scalars['BigInt']['output'];
  totalIngest: Scalars['BigInt']['output'];
};

export type ConfigurationVersions = {
  __typename?: 'ConfigurationVersions';
  current: Scalars['String']['output'];
  future: Scalars['String']['output'];
  pending: Scalars['String']['output'];
};

export type Configurations = {
  __typename?: 'Configurations';
  configurations: Array<Configuration>;
  query?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Suggestion>>;
};

export type DeleteInvitationInput = {
  invitationId: Scalars['String']['input'];
};

export type Destination = {
  __typename?: 'Destination';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ParameterizedSpec;
};

export type DestinationType = {
  __typename?: 'DestinationType';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ResourceTypeSpec;
};

export type DestinationWithType = {
  __typename?: 'DestinationWithType';
  destination?: Maybe<Destination>;
  destinationType?: Maybe<DestinationType>;
};

export type DestinationsSummaryDataPoint = {
  __typename?: 'DestinationsSummaryDataPoint';
  destinationName: Scalars['String']['output'];
  totalEgress: Scalars['BigInt']['output'];
};

export type DocumentationLink = {
  __typename?: 'DocumentationLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Edge = {
  __typename?: 'Edge';
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type EdgeMetric = {
  __typename?: 'EdgeMetric';
  edgeID: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pipelineType: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type EditConfigurationDescriptionInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type EditUserRoleInput = {
  role: Role;
  userId: Scalars['String']['input'];
};

export enum EventType {
  Insert = 'INSERT',
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export type Extension = {
  __typename?: 'Extension';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ParameterizedSpec;
};

export type ExtensionType = {
  __typename?: 'ExtensionType';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ResourceTypeSpec;
};

export type ExtensionWithType = {
  __typename?: 'ExtensionWithType';
  extension?: Maybe<Extension>;
  extensionType?: Maybe<ExtensionType>;
};

export type Graph = {
  __typename?: 'Graph';
  attributes: Scalars['Map']['output'];
  edges: Array<Edge>;
  intermediates: Array<Node>;
  sources: Array<Node>;
  targets: Array<Node>;
};

export type GraphMetric = {
  __typename?: 'GraphMetric';
  agentID?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  nodeID: Scalars['String']['output'];
  pipelineType: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GraphMetrics = {
  __typename?: 'GraphMetrics';
  edgeMetrics: Array<EdgeMetric>;
  maxLogValue: Scalars['Float']['output'];
  maxMetricValue: Scalars['Float']['output'];
  maxTraceValue: Scalars['Float']['output'];
  metrics: Array<GraphMetric>;
};

export type Invitation = {
  __typename?: 'Invitation';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiredAt: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  redeemedAt?: Maybe<Scalars['Time']['output']>;
  redeemedBy?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  status: InvitationStatus;
};

export enum InvitationStatus {
  Expired = 'expired',
  Outstanding = 'outstanding',
  Redeemed = 'redeemed'
}

export enum Kind {
  Account = 'Account',
  Agent = 'Agent',
  AgentVersion = 'AgentVersion',
  AuditTrail = 'AuditTrail',
  Configuration = 'Configuration',
  Destination = 'Destination',
  DestinationType = 'DestinationType',
  Extension = 'Extension',
  ExtensionType = 'ExtensionType',
  Invitation = 'Invitation',
  Login = 'Login',
  Processor = 'Processor',
  ProcessorType = 'ProcessorType',
  Rollout = 'Rollout',
  Source = 'Source',
  SourceType = 'SourceType',
  Unknown = 'Unknown',
  User = 'User',
  UserAccountBinding = 'UserAccountBinding'
}

export type Log = {
  __typename?: 'Log';
  attributes?: Maybe<Scalars['Map']['output']>;
  body?: Maybe<Scalars['Any']['output']>;
  resource?: Maybe<Scalars['Map']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Time']['output']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  additionalInfo?: Maybe<AdditionalInfo>;
  dateModified?: Maybe<Scalars['Time']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labels?: Maybe<Scalars['Map']['output']>;
  name: Scalars['String']['output'];
  resourceDocLink?: Maybe<Scalars['String']['output']>;
  version: Scalars['Version']['output'];
};

export type Metric = {
  __typename?: 'Metric';
  attributes?: Maybe<Scalars['Map']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['Map']['output']>;
  timestamp?: Maybe<Scalars['Time']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Any']['output']>;
};

export type MetricCategory = {
  __typename?: 'MetricCategory';
  column: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  metrics: Array<MetricOption>;
};

export type MetricOption = {
  __typename?: 'MetricOption';
  defaultDisabled?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  kpi?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  changeAccount: User;
  clearAgentUpgradeError?: Maybe<Scalars['Boolean']['output']>;
  createAPIKey: NewApiKeyResponse;
  deleteInvitation?: Maybe<Scalars['Boolean']['output']>;
  editConfigurationDescription?: Maybe<Scalars['Boolean']['output']>;
  editRole: Array<User>;
  newInvitation: Invitation;
  removeAgentConfiguration?: Maybe<Agent>;
  removeUser: Array<User>;
  updateProcessors?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationChangeAccountArgs = {
  input: ChangeAccountInput;
};


export type MutationClearAgentUpgradeErrorArgs = {
  input: ClearAgentUpgradeErrorInput;
};


export type MutationDeleteInvitationArgs = {
  input: DeleteInvitationInput;
};


export type MutationEditConfigurationDescriptionArgs = {
  input: EditConfigurationDescriptionInput;
};


export type MutationEditRoleArgs = {
  input: EditUserRoleInput;
};


export type MutationNewInvitationArgs = {
  input?: InputMaybe<NewInvitationInput>;
};


export type MutationRemoveAgentConfigurationArgs = {
  input?: InputMaybe<RemoveAgentConfigurationInput>;
};


export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationUpdateProcessorsArgs = {
  input: UpdateProcessorsInput;
};

export type NewApiKeyResponse = {
  __typename?: 'NewAPIKeyResponse';
  configureCommand: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type NewInvitationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  role: Role;
};

export type Node = {
  __typename?: 'Node';
  attributes: Scalars['Map']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OverviewPage = {
  __typename?: 'OverviewPage';
  graph: Graph;
};

export type Parameter = {
  __typename?: 'Parameter';
  name: Scalars['String']['output'];
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['Any']['output'];
};

export type ParameterDefinition = {
  __typename?: 'ParameterDefinition';
  advancedConfig?: Maybe<Scalars['Boolean']['output']>;
  default?: Maybe<Scalars['Any']['output']>;
  description: Scalars['String']['output'];
  documentation?: Maybe<Array<DocumentationLink>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: ParameterOptions;
  relevantIf?: Maybe<Array<RelevantIfCondition>>;
  required: Scalars['Boolean']['output'];
  type: ParameterType;
  validValues?: Maybe<Array<Scalars['String']['output']>>;
};

export type ParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['Any']['input'];
};

export type ParameterOptions = {
  __typename?: 'ParameterOptions';
  creatable?: Maybe<Scalars['Boolean']['output']>;
  gridColumns?: Maybe<Scalars['Int']['output']>;
  horizontalDivider?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Scalars['Map']['output']>;
  metricCategories?: Maybe<Array<MetricCategory>>;
  multiline?: Maybe<Scalars['Boolean']['output']>;
  ottlContext?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['Boolean']['output']>;
  sectionHeader?: Maybe<Scalars['Boolean']['output']>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  subHeader?: Maybe<Scalars['String']['output']>;
  trackUnchecked?: Maybe<Scalars['Boolean']['output']>;
};

export enum ParameterType {
  AwsCloudwatchNamedField = 'awsCloudwatchNamedField',
  Bool = 'bool',
  Enum = 'enum',
  EnumList = 'enumList',
  Enums = 'enums',
  FileLogSort = 'fileLogSort',
  Fraction = 'fraction',
  Int = 'int',
  Map = 'map',
  MapToEnum = 'mapToEnum',
  Metrics = 'metrics',
  OttlField = 'ottlField',
  String = 'string',
  Strings = 'strings',
  Timezone = 'timezone',
  Yaml = 'yaml'
}

export type ParameterizedResource = {
  __typename?: 'ParameterizedResource';
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ParameterizedSpec;
};

export type ParameterizedResourceWithType = {
  __typename?: 'ParameterizedResourceWithType';
  resource?: Maybe<ParameterizedResource>;
  resourceType?: Maybe<ResourceType>;
};

export type ParameterizedSpec = {
  __typename?: 'ParameterizedSpec';
  disabled: Scalars['Boolean']['output'];
  parameters?: Maybe<Array<Parameter>>;
  processors?: Maybe<Array<ResourceConfiguration>>;
  type: Scalars['String']['output'];
};

export type PhaseAgentCount = {
  __typename?: 'PhaseAgentCount';
  initial: Scalars['Int']['output'];
  maximum: Scalars['Int']['output'];
  multiplier: Scalars['Float']['output'];
};

export enum PipelineType {
  Logs = 'logs',
  Metrics = 'metrics',
  Traces = 'traces'
}

export type Processor = {
  __typename?: 'Processor';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ParameterizedSpec;
};

export type ProcessorInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Array<ParameterInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorType = {
  __typename?: 'ProcessorType';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ResourceTypeSpec;
};

export type ProcessorWithType = {
  __typename?: 'ProcessorWithType';
  processor?: Maybe<Processor>;
  processorType?: Maybe<ProcessorType>;
};

export type Query = {
  __typename?: 'Query';
  accounts: Array<Account>;
  agent?: Maybe<Agent>;
  agentHealthMetrics: Array<Maybe<Metric>>;
  agentMetrics: GraphMetrics;
  agentMonitoring: AgentMonitoringSummary;
  agents: Agents;
  agentsTable: AgentsTable;
  auditEvents: Array<AuditEvent>;
  configuration?: Maybe<Configuration>;
  configurationCount: Scalars['Int']['output'];
  configurationHistory: Array<Configuration>;
  configurationMetrics: GraphMetrics;
  configurationMonitoring: ConfigurationMonitoringSummary;
  configurationSummary: Array<ConfigurationSummary>;
  configurationVersions: Array<Configuration>;
  configurations: Configurations;
  destination?: Maybe<Destination>;
  destinationType?: Maybe<DestinationType>;
  destinationTypes: Array<DestinationType>;
  destinationWithType: DestinationWithType;
  destinations: Array<Destination>;
  destinationsSummary: Array<DestinationsSummaryDataPoint>;
  destinationsSummaryForTelemetryTypes: Array<DestinationsSummaryDataPoint>;
  extension?: Maybe<Extension>;
  extensionType?: Maybe<ExtensionType>;
  extensionTypes: Array<ExtensionType>;
  extensionWithType: ExtensionWithType;
  extensions: Array<Extension>;
  featureGate: Scalars['Boolean']['output'];
  findApiKey?: Maybe<ApiKey>;
  invitations: Array<Invitation>;
  overviewMetrics: GraphMetrics;
  overviewPage: OverviewPage;
  processor?: Maybe<Processor>;
  processorType?: Maybe<ProcessorType>;
  processorTypes: Array<ProcessorType>;
  processorWithType: ProcessorWithType;
  processors: Array<Processor>;
  resourceType?: Maybe<ResourceType>;
  resourceTypes: Array<ResourceType>;
  resourceWithType: ParameterizedResourceWithType;
  snapshot: Snapshot;
  snapshotProcessed: SnapshotProcessed;
  snapshotSearchSupported: Scalars['Boolean']['output'];
  source?: Maybe<Source>;
  sourceType?: Maybe<SourceType>;
  sourceTypes: Array<SourceType>;
  sourceWithType: SourceWithType;
  sources: Array<Source>;
  sourcesSummary: Array<SourcesSummaryDataPoint>;
  summaryGraphData: SummaryGraphData;
  user: User;
  users: Array<User>;
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentHealthMetricsArgs = {
  id: Scalars['ID']['input'];
  interval: Scalars['String']['input'];
};


export type QueryAgentMetricsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  period: Scalars['String']['input'];
};


export type QueryAgentsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  selector?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentsTableArgs = {
  options: AgentsTableOptions;
};


export type QueryAuditEventsArgs = {
  options?: InputMaybe<AuditEventFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConfigurationArgs = {
  name: Scalars['String']['input'];
};


export type QueryConfigurationCountArgs = {
  query: Scalars['String']['input'];
};


export type QueryConfigurationHistoryArgs = {
  name: Scalars['String']['input'];
};


export type QueryConfigurationMetricsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  period: Scalars['String']['input'];
};


export type QueryConfigurationSummaryArgs = {
  interval: Scalars['String']['input'];
  period: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
};


export type QueryConfigurationVersionsArgs = {
  name: Scalars['String']['input'];
};


export type QueryConfigurationsArgs = {
  onlyDeployedConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  selector?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDestinationArgs = {
  name: Scalars['String']['input'];
};


export type QueryDestinationTypeArgs = {
  name: Scalars['String']['input'];
};


export type QueryDestinationWithTypeArgs = {
  name: Scalars['String']['input'];
};


export type QueryDestinationsArgs = {
  filterUnused?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDestinationsSummaryArgs = {
  interval: Scalars['String']['input'];
  period: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
};


export type QueryDestinationsSummaryForTelemetryTypesArgs = {
  interval: Scalars['String']['input'];
  names: Array<Scalars['String']['input']>;
  period: Scalars['String']['input'];
  telemetryTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryExtensionArgs = {
  name: Scalars['String']['input'];
};


export type QueryExtensionTypeArgs = {
  name: Scalars['String']['input'];
};


export type QueryExtensionWithTypeArgs = {
  name: Scalars['String']['input'];
};


export type QueryFeatureGateArgs = {
  id: Scalars['String']['input'];
};


export type QueryOverviewMetricsArgs = {
  configIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  period: Scalars['String']['input'];
};


export type QueryOverviewPageArgs = {
  configIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProcessorArgs = {
  name: Scalars['String']['input'];
};


export type QueryProcessorTypeArgs = {
  name: Scalars['String']['input'];
};


export type QueryProcessorWithTypeArgs = {
  name: Scalars['String']['input'];
};


export type QueryResourceTypeArgs = {
  kind: Kind;
  name: Scalars['String']['input'];
};


export type QueryResourceTypesArgs = {
  kind: Kind;
};


export type QueryResourceWithTypeArgs = {
  kind: Kind;
  name: Scalars['String']['input'];
};


export type QuerySnapshotArgs = {
  agentID: Scalars['String']['input'];
  pipelineType: PipelineType;
  position?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type QuerySnapshotProcessedArgs = {
  agentID: Scalars['String']['input'];
  pipelineType: PipelineType;
  position?: InputMaybe<Scalars['String']['input']>;
  processorsJSON?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type QuerySnapshotSearchSupportedArgs = {
  agentID: Scalars['String']['input'];
};


export type QuerySourceArgs = {
  name: Scalars['String']['input'];
};


export type QuerySourceTypeArgs = {
  name: Scalars['String']['input'];
};


export type QuerySourceWithTypeArgs = {
  name: Scalars['String']['input'];
};


export type QuerySourcesSummaryArgs = {
  interval: Scalars['String']['input'];
  names: Array<Scalars['String']['input']>;
  period: Scalars['String']['input'];
  telemetryTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySummaryGraphDataArgs = {
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  interval: Scalars['String']['input'];
  period: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
};

export type RelevantIfCondition = {
  __typename?: 'RelevantIfCondition';
  name: Scalars['String']['output'];
  operator: RelevantIfOperatorType;
  value: Scalars['Any']['output'];
};

export enum RelevantIfOperatorType {
  ContainsAny = 'containsAny',
  Equals = 'equals',
  NotEquals = 'notEquals'
}

export type RemoveAgentConfigurationInput = {
  agentId: Scalars['String']['input'];
};

export type RemoveUserInput = {
  userId: Scalars['String']['input'];
};

export type ResourceConfiguration = {
  __typename?: 'ResourceConfiguration';
  disabled: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Array<Parameter>>;
  processors?: Maybe<Array<ResourceConfiguration>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ResourceType = {
  __typename?: 'ResourceType';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ResourceTypeSpec;
};

export enum ResourceTypeKind {
  Destination = 'DESTINATION',
  Source = 'SOURCE'
}

export type ResourceTypeSpec = {
  __typename?: 'ResourceTypeSpec';
  parameters: Array<ParameterDefinition>;
  supportedPlatforms: Array<Scalars['String']['output']>;
  telemetryTypes: Array<PipelineType>;
  version: Scalars['String']['output'];
};

export enum Role {
  Admin = 'admin',
  User = 'user',
  Viewer = 'viewer'
}

export type Rollout = {
  __typename?: 'Rollout';
  completed: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  options?: Maybe<RolloutOptions>;
  pending: Scalars['Int']['output'];
  phase: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['RolloutStatus']['output'];
  waiting: Scalars['Int']['output'];
};

export type RolloutOptions = {
  __typename?: 'RolloutOptions';
  maxErrors: Scalars['Int']['output'];
  phaseAgentCount?: Maybe<PhaseAgentCount>;
  rollbackOnFailure: Scalars['Boolean']['output'];
  startAutomatically: Scalars['Boolean']['output'];
};

export type Snapshot = {
  __typename?: 'Snapshot';
  logs: Array<Log>;
  metrics: Array<Metric>;
  traces: Array<Trace>;
};

export type SnapshotProcessed = {
  __typename?: 'SnapshotProcessed';
  logs: Array<Log>;
  metrics: Array<Metric>;
  processedLogs: Array<Log>;
  processedMetrics: Array<Metric>;
  processedTraces: Array<Trace>;
  traces: Array<Trace>;
};

export type Source = {
  __typename?: 'Source';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ParameterizedSpec;
};

export type SourceType = {
  __typename?: 'SourceType';
  apiVersion: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata: Metadata;
  spec: ResourceTypeSpec;
};

export type SourceWithType = {
  __typename?: 'SourceWithType';
  source?: Maybe<Source>;
  sourceType?: Maybe<SourceType>;
};

export type SourcesSummaryDataPoint = {
  __typename?: 'SourcesSummaryDataPoint';
  sourceName: Scalars['String']['output'];
  totalIngest: Scalars['BigInt']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  agentDetailsChanged?: Maybe<Scalars['Boolean']['output']>;
  agentMetrics: GraphMetrics;
  agentsTableChanged?: Maybe<Scalars['Boolean']['output']>;
  configurationChanges: Array<ConfigurationChange>;
  configurationMetrics: GraphMetrics;
  invitations: Array<Invitation>;
  overviewMetrics: GraphMetrics;
  summaryGraphData: SummaryGraphData;
  users: Array<User>;
};


export type SubscriptionAgentDetailsChangedArgs = {
  agentID?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAgentMetricsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  period: Scalars['String']['input'];
};


export type SubscriptionAgentsTableChangedArgs = {
  agentIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  selector?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionConfigurationChangesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  selector?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionConfigurationMetricsArgs = {
  agent?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  period: Scalars['String']['input'];
};


export type SubscriptionOverviewMetricsArgs = {
  configIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  period: Scalars['String']['input'];
};


export type SubscriptionSummaryGraphDataArgs = {
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  interval: Scalars['String']['input'];
  period: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
};

export type Suggestion = {
  __typename?: 'Suggestion';
  label: Scalars['String']['output'];
  query: Scalars['String']['output'];
};

export type SummaryGraphData = {
  __typename?: 'SummaryGraphData';
  dataset: Array<SummaryGraphDataPoint>;
  totalEgress: Scalars['BigInt']['output'];
  totalIngest: Scalars['BigInt']['output'];
};

export type SummaryGraphDataPoint = {
  __typename?: 'SummaryGraphDataPoint';
  d1Value: Scalars['BigInt']['output'];
  s0Value: Scalars['BigInt']['output'];
  timestamp: Scalars['Time']['output'];
};

export type Trace = {
  __typename?: 'Trace';
  attributes?: Maybe<Scalars['Map']['output']>;
  end?: Maybe<Scalars['Time']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentSpanID?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['Map']['output']>;
  spanID?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Time']['output']>;
  traceID?: Maybe<Scalars['String']['output']>;
};

export type UpdateProcessorsInput = {
  configuration: Scalars['String']['input'];
  processors: Array<ProcessorInput>;
  resourceIndex: Scalars['Int']['input'];
  resourceType: ResourceTypeKind;
};

export type User = {
  __typename?: 'User';
  metadata: Metadata;
  role: Role;
  spec: UserSpec;
};

export type UserSpec = {
  __typename?: 'UserSpec';
  activeAccount: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type GetAgentMonitoringSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentMonitoringSummaryQuery = { __typename?: 'Query', agentMonitoring: { __typename?: 'AgentMonitoringSummary', total: number, disconnected: number, errored: number, outdated: number, connected: number } };

export type SourceTypeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type SourceTypeQuery = { __typename?: 'Query', sourceType?: { __typename?: 'SourceType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null, icon?: string | null, description?: string | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, options: { __typename?: 'ParameterOptions', creatable?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } } | null };

export type GetDestinationWithTypeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetDestinationWithTypeQuery = { __typename?: 'Query', destinationWithType: { __typename?: 'DestinationWithType', destination?: { __typename?: 'Destination', metadata: { __typename?: 'Metadata', name: string, version: number, id: string, labels?: any | null }, spec: { __typename?: 'ParameterizedSpec', type: string, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } } | null, destinationType?: { __typename?: 'DestinationType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, icon?: string | null, description?: string | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', multiline?: boolean | null, creatable?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } } | null } };

export type GetSourceWithTypeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetSourceWithTypeQuery = { __typename?: 'Query', sourceWithType: { __typename?: 'SourceWithType', source?: { __typename?: 'Source', metadata: { __typename?: 'Metadata', name: string, version: number, id: string, labels?: any | null, displayName?: string | null }, spec: { __typename?: 'ParameterizedSpec', type: string, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } } | null, sourceType?: { __typename?: 'SourceType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, icon?: string | null, description?: string | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', multiline?: boolean | null, creatable?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } } | null } };

export type GetConfigurationExtensionsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetConfigurationExtensionsQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', metadata: { __typename?: 'Metadata', name: string, id: string, version: number }, spec: { __typename?: 'ConfigurationSpec', extensions?: Array<{ __typename?: 'ResourceConfiguration', name?: string | null, id?: string | null, type?: string | null }> | null } } | null };

export type GetCurrentConfigVersionQueryVariables = Exact<{
  configurationName: Scalars['String']['input'];
}>;


export type GetCurrentConfigVersionQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', agentCount?: number | null, metadata: { __typename?: 'Metadata', id: string, name: string, version: number, labels?: any | null } } | null };

export type GetLatestConfigDescriptionQueryVariables = Exact<{
  configurationName: Scalars['String']['input'];
}>;


export type GetLatestConfigDescriptionQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, description?: string | null, labels?: any | null } } | null };

export type EditConfigDescriptionMutationVariables = Exact<{
  input: EditConfigurationDescriptionInput;
}>;


export type EditConfigDescriptionMutation = { __typename?: 'Mutation', editConfigurationDescription?: boolean | null };

export type GetConfigurationVersionsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetConfigurationVersionsQuery = { __typename?: 'Query', configurationVersions: Array<{ __typename?: 'Configuration', activeTypes?: Array<string> | null, metadata: { __typename?: 'Metadata', name: string, id: string, version: number }, status: { __typename?: 'ConfigurationStatus', current: boolean, pending: boolean, latest: boolean } }> };

export type GetLatestMeasurementIntervalQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetLatestMeasurementIntervalQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', metadata: { __typename?: 'Metadata', name: string, id: string, version: number }, spec: { __typename?: 'ConfigurationSpec', measurementInterval?: string | null } } | null };

export type GetConfigurationMonitoringSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigurationMonitoringSummaryQuery = { __typename?: 'Query', configurationMonitoring: { __typename?: 'ConfigurationMonitoringSummary', total: number, errored: number, pending: number } };

export type GetConfigurationSummaryQueryVariables = Exact<{
  period: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
}>;


export type GetConfigurationSummaryQuery = { __typename?: 'Query', configurationSummary: Array<{ __typename?: 'ConfigurationSummary', name: string, totalIngest: number, totalEgress: number, dataset: Array<{ __typename?: 'SummaryGraphDataPoint', timestamp: any, s0Value: number, d1Value: number }> }> };

export type GetSummaryGraphQueryVariables = Exact<{
  period: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetSummaryGraphQuery = { __typename?: 'Query', summaryGraphData: { __typename?: 'SummaryGraphData', totalIngest: number, totalEgress: number, dataset: Array<{ __typename?: 'SummaryGraphDataPoint', timestamp: any, s0Value: number, d1Value: number }> } };

export type SummaryGraphDataSubscriptionVariables = Exact<{
  period: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SummaryGraphDataSubscription = { __typename?: 'Subscription', summaryGraphData: { __typename?: 'SummaryGraphData', totalIngest: number, totalEgress: number, dataset: Array<{ __typename?: 'SummaryGraphDataPoint', timestamp: any, s0Value: number, d1Value: number }> } };

export type GetRenderedConfigQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetRenderedConfigQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', rendered?: string | null, metadata: { __typename?: 'Metadata', name: string, id: string, version: number } } | null };

export type GetVersionHistoryQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetVersionHistoryQuery = { __typename?: 'Query', configurationHistory: Array<{ __typename?: 'Configuration', metadata: { __typename?: 'Metadata', name: string, id: string, version: number }, status: { __typename?: 'ConfigurationStatus', current: boolean, pending: boolean, latest: boolean } }> };

export type PaginatedAgentsTableQueryVariables = Exact<{
  options: AgentsTableOptions;
}>;


export type PaginatedAgentsTableQuery = { __typename?: 'Query', agentsTable: { __typename?: 'AgentsTable', agentCount: number, query: string, latestVersion: string, agents: Array<{ __typename?: 'Agent', id: string, labels?: any | null, version?: string | null, name: string, status: number, operatingSystem?: string | null, configurationStatus: { __typename?: 'ConfigurationVersions', current: string } }>, suggestions: Array<{ __typename?: 'Suggestion', query: string, label: string }>, agentMetrics: Array<{ __typename?: 'GraphMetric', name: string, nodeID: string, unit: string, value: number, agentID?: string | null, pipelineType: string }> } };

export type AgentsTableChangedSubscriptionVariables = Exact<{
  agentIDs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  selector?: InputMaybe<Scalars['String']['input']>;
}>;


export type AgentsTableChangedSubscription = { __typename?: 'Subscription', agentsTableChanged?: boolean | null };

export type ProcessorDialogSourceTypeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type ProcessorDialogSourceTypeQuery = { __typename?: 'Query', sourceType?: { __typename?: 'SourceType', metadata: { __typename?: 'Metadata', name: string, id: string, version: number, displayName?: string | null, description?: string | null }, spec: { __typename?: 'ResourceTypeSpec', telemetryTypes: Array<PipelineType> } } | null };

export type ProcessorDialogDestinationTypeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type ProcessorDialogDestinationTypeQuery = { __typename?: 'Query', destinationWithType: { __typename?: 'DestinationWithType', destinationType?: { __typename?: 'DestinationType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null, description?: string | null }, spec: { __typename?: 'ResourceTypeSpec', telemetryTypes: Array<PipelineType> } } | null } };

export type UpdateProcessorsMutationVariables = Exact<{
  input: UpdateProcessorsInput;
}>;


export type UpdateProcessorsMutation = { __typename?: 'Mutation', updateProcessors?: boolean | null };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', activeAccount: string } }, accounts: Array<{ __typename?: 'Account', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null } }> };

export type ChangeAccountMutationVariables = Exact<{
  input: ChangeAccountInput;
}>;


export type ChangeAccountMutation = { __typename?: 'Mutation', changeAccount: { __typename?: 'User', metadata: { __typename?: 'Metadata', name: string, id: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', activeAccount: string } } };

export type GetFeatureGateQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type GetFeatureGateQuery = { __typename?: 'Query', enabled: boolean };

export type EditUserRoleMutationVariables = Exact<{
  input: EditUserRoleInput;
}>;


export type EditUserRoleMutation = { __typename?: 'Mutation', editRole: Array<{ __typename?: 'User', role: Role, metadata: { __typename?: 'Metadata', name: string, id: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', activeAccount: string, email: string } }> };

export type DeleteInvitationMutationVariables = Exact<{
  input: DeleteInvitationInput;
}>;


export type DeleteInvitationMutation = { __typename?: 'Mutation', deleteInvitation?: boolean | null };

export type NewInvitationMutationVariables = Exact<{
  input?: InputMaybe<NewInvitationInput>;
}>;


export type NewInvitationMutation = { __typename?: 'Mutation', newInvitation: { __typename?: 'Invitation', id: string, accountId: string, createdAt: any, redeemedAt?: any | null, redeemedBy?: string | null, link: string } };

export type RemoveAgentConfigurationMutationVariables = Exact<{
  input: RemoveAgentConfigurationInput;
}>;


export type RemoveAgentConfigurationMutation = { __typename?: 'Mutation', removeAgentConfiguration?: { __typename?: 'Agent', id: string, configurationResource?: { __typename?: 'Configuration', rendered?: string | null } | null } | null };

export type PreviewFeatureGateQueryVariables = Exact<{ [key: string]: never; }>;


export type PreviewFeatureGateQuery = { __typename?: 'Query', featureGate: boolean };

export type ConfigurationMetricsSubscriptionVariables = Exact<{
  period: Scalars['String']['input'];
  name: Scalars['String']['input'];
  agent?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfigurationMetricsSubscription = { __typename?: 'Subscription', configurationMetrics: { __typename?: 'GraphMetrics', maxMetricValue: number, maxLogValue: number, maxTraceValue: number, metrics: Array<{ __typename?: 'GraphMetric', name: string, nodeID: string, pipelineType: string, value: number, unit: string }> } };

export type ProcessorsWithParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessorsWithParamsQuery = { __typename?: 'Query', processors: Array<{ __typename?: 'Processor', metadata: { __typename?: 'Metadata', id: string, version: number, name: string }, spec: { __typename?: 'ParameterizedSpec', type: string, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } }> };

export type GetRolloutHistoryQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetRolloutHistoryQuery = { __typename?: 'Query', configurationHistory: Array<{ __typename?: 'Configuration', metadata: { __typename?: 'Metadata', name: string, id: string, version: number, dateModified?: any | null }, status: { __typename?: 'ConfigurationStatus', rollout: { __typename?: 'Rollout', status: number, errors: number, startedAt?: any | null } } }> };

export type GetConfigRolloutStatusQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetConfigRolloutStatusQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', agentCount?: number | null, metadata: { __typename?: 'Metadata', name: string, id: string, version: number, dateModified?: any | null }, status: { __typename?: 'ConfigurationStatus', pending: boolean, current: boolean, latest: boolean, rollout: { __typename?: 'Rollout', status: number, phase: number, completed: number, errors: number, pending: number, waiting: number } } } | null };

export type AgentsWithConfigurationQueryVariables = Exact<{
  selector?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type AgentsWithConfigurationQuery = { __typename?: 'Query', agents: { __typename?: 'Agents', agents: Array<{ __typename?: 'Agent', id: string, name: string }> } };

export type SnapshotQueryVariables = Exact<{
  agentID: Scalars['String']['input'];
  pipelineType: PipelineType;
  position?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
}>;


export type SnapshotQuery = { __typename?: 'Query', snapshot: { __typename?: 'Snapshot', metrics: Array<{ __typename?: 'Metric', name?: string | null, timestamp?: any | null, value?: any | null, unit?: string | null, type?: string | null, attributes?: any | null, resource?: any | null }>, logs: Array<{ __typename?: 'Log', timestamp?: any | null, body?: any | null, severity?: string | null, attributes?: any | null, resource?: any | null }>, traces: Array<{ __typename?: 'Trace', name?: string | null, traceID?: string | null, spanID?: string | null, parentSpanID?: string | null, start?: any | null, end?: any | null, attributes?: any | null, resource?: any | null }> } };

export type SnapshotSearchSupportedQueryVariables = Exact<{
  agentID: Scalars['String']['input'];
}>;


export type SnapshotSearchSupportedQuery = { __typename?: 'Query', snapshotSearchSupported: boolean };

export type GetConfigurationTableQueryVariables = Exact<{
  selector?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  onlyDeployedConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConfigurationTableQuery = { __typename?: 'Query', configurations: { __typename?: 'Configurations', query?: string | null, configurations: Array<{ __typename?: 'Configuration', agentCount?: number | null, metadata: { __typename?: 'Metadata', id: string, version: number, name: string, labels?: any | null, description?: string | null } }>, suggestions?: Array<{ __typename?: 'Suggestion', query: string, label: string }> | null } };

export type ConfigurationChangesSubscriptionVariables = Exact<{
  selector?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfigurationChangesSubscription = { __typename?: 'Subscription', configurationChanges: Array<{ __typename?: 'ConfigurationChange', eventType: EventType, configuration: { __typename?: 'Configuration', agentCount?: number | null, metadata: { __typename?: 'Metadata', id: string, version: number, name: string, description?: string | null, labels?: any | null } } }> };

export type ConfigurationTableMetricsSubscriptionVariables = Exact<{
  period: Scalars['String']['input'];
}>;


export type ConfigurationTableMetricsSubscription = { __typename?: 'Subscription', overviewMetrics: { __typename?: 'GraphMetrics', metrics: Array<{ __typename?: 'GraphMetric', name: string, nodeID: string, pipelineType: string, value: number, unit: string }> } };

export type DestinationsSummaryMetricsQueryVariables = Exact<{
  names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DestinationsSummaryMetricsQuery = { __typename?: 'Query', destinationsSummaryForTelemetryTypes: Array<{ __typename?: 'DestinationsSummaryDataPoint', destinationName: string, totalEgress: number }> };

export type GetDestinationTypeDisplayInfoQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetDestinationTypeDisplayInfoQuery = { __typename?: 'Query', destinationType?: { __typename?: 'DestinationType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null, icon?: string | null } } | null };

export type GetSourceTypeDisplayInfoQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetSourceTypeDisplayInfoQuery = { __typename?: 'Query', sourceType?: { __typename?: 'SourceType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null, icon?: string | null } } | null };

export type GetProcessorWithTypeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetProcessorWithTypeQuery = { __typename?: 'Query', processorWithType: { __typename?: 'ProcessorWithType', processor?: { __typename?: 'Processor', metadata: { __typename?: 'Metadata', name: string, version: number, id: string, labels?: any | null }, spec: { __typename?: 'ParameterizedSpec', type: string, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } } | null, processorType?: { __typename?: 'ProcessorType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, icon?: string | null, description?: string | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', multiline?: boolean | null, creatable?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } } | null } };

export type ProcessorTypeDisplayInfoQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type ProcessorTypeDisplayInfoQuery = { __typename?: 'Query', processorType?: { __typename?: 'ProcessorType', metadata: { __typename?: 'Metadata', id: string, displayName?: string | null, name: string, version: number } } | null };

export type ConfigurationCountQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type ConfigurationCountQuery = { __typename?: 'Query', configurationCount: number };

export type SourcesSummaryQueryVariables = Exact<{
  names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SourcesSummaryQuery = { __typename?: 'Query', sourcesSummary: Array<{ __typename?: 'SourcesSummaryDataPoint', sourceName: string, totalIngest: number }> };

export type ClearAgentUpgradeErrorMutationVariables = Exact<{
  input: ClearAgentUpgradeErrorInput;
}>;


export type ClearAgentUpgradeErrorMutation = { __typename?: 'Mutation', clearAgentUpgradeError?: boolean | null };

export type SnapshotProcessedQueryVariables = Exact<{
  agentID: Scalars['String']['input'];
  pipelineType: PipelineType;
  position?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  processorsJSON?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
}>;


export type SnapshotProcessedQuery = { __typename?: 'Query', snapshotProcessed: { __typename?: 'SnapshotProcessed', metrics: Array<{ __typename?: 'Metric', name?: string | null, timestamp?: any | null, value?: any | null, unit?: string | null, type?: string | null, attributes?: any | null, resource?: any | null }>, logs: Array<{ __typename?: 'Log', timestamp?: any | null, body?: any | null, severity?: string | null, attributes?: any | null, resource?: any | null }>, traces: Array<{ __typename?: 'Trace', name?: string | null, traceID?: string | null, spanID?: string | null, parentSpanID?: string | null, start?: any | null, end?: any | null, attributes?: any | null, resource?: any | null }>, processedMetrics: Array<{ __typename?: 'Metric', name?: string | null, timestamp?: any | null, value?: any | null, unit?: string | null, type?: string | null, attributes?: any | null, resource?: any | null }>, processedLogs: Array<{ __typename?: 'Log', timestamp?: any | null, body?: any | null, severity?: string | null, attributes?: any | null, resource?: any | null }>, processedTraces: Array<{ __typename?: 'Trace', name?: string | null, traceID?: string | null, spanID?: string | null, parentSpanID?: string | null, start?: any | null, end?: any | null, attributes?: any | null, resource?: any | null }> } };

export type GetUserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRoleQuery = { __typename?: 'Query', user: { __typename?: 'User', role: Role, metadata: { __typename?: 'Metadata', name: string, id: string, version: number } } };

export type GetResourceTypeQueryVariables = Exact<{
  kind: Kind;
  name: Scalars['String']['input'];
}>;


export type GetResourceTypeQuery = { __typename?: 'Query', resourceType?: { __typename?: 'ResourceType', metadata: { __typename?: 'Metadata', displayName?: string | null, name: string, version: number, id: string, description?: string | null, deprecated?: boolean | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', creatable?: boolean | null, trackUnchecked?: boolean | null, gridColumns?: number | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, multiline?: boolean | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, ottlContext?: string | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } } | null };

export type GetResourceTypesQueryVariables = Exact<{
  kind: Kind;
}>;


export type GetResourceTypesQuery = { __typename?: 'Query', resourceTypes: Array<{ __typename?: 'ResourceType', metadata: { __typename?: 'Metadata', displayName?: string | null, description?: string | null, name: string, labels?: any | null, version: number, id: string, deprecated?: boolean | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', telemetryTypes: Array<PipelineType>, parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', creatable?: boolean | null, trackUnchecked?: boolean | null, gridColumns?: number | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, multiline?: boolean | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, ottlContext?: string | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } }> };

export type GetResourceWithTypeQueryVariables = Exact<{
  kind: Kind;
  name: Scalars['String']['input'];
}>;


export type GetResourceWithTypeQuery = { __typename?: 'Query', resourceWithType: { __typename?: 'ParameterizedResourceWithType', resource?: { __typename?: 'ParameterizedResource', metadata: { __typename?: 'Metadata', name: string, version: number, id: string, labels?: any | null }, spec: { __typename?: 'ParameterizedSpec', type: string, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } } | null, resourceType?: { __typename?: 'ResourceType', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, description?: string | null, displayName?: string | null, deprecated?: boolean | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', parameters: Array<{ __typename?: 'ParameterDefinition', label: string, name: string, description: string, required: boolean, type: ParameterType, default?: any | null, advancedConfig?: boolean | null, validValues?: Array<string> | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', multiline?: boolean | null, creatable?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, ottlContext?: string | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } } | null } };

export type FindApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindApiKeyQuery = { __typename?: 'Query', findApiKey?: { __typename?: 'APIKey', id: string, createdAt: any } | null };

export type NewApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type NewApiKeyMutation = { __typename?: 'Mutation', createAPIKey: { __typename?: 'NewAPIKeyResponse', key: string, configureCommand: string } };

export type GetAccountPageInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountPageInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', role: Role, metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', activeAccount: string, email: string } }, users: Array<{ __typename?: 'User', role: Role, metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', activeAccount: string, email: string } }>, accounts: Array<{ __typename?: 'Account', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null } }> };

export type RemoveUserMutationVariables = Exact<{
  input: RemoveUserInput;
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: Array<{ __typename?: 'User', role: Role, metadata: { __typename?: 'Metadata', name: string, id: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', activeAccount: string, email: string } }> };

export type UsersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UsersSubscription = { __typename?: 'Subscription', users: Array<{ __typename?: 'User', role: Role, metadata: { __typename?: 'Metadata', name: string, id: string, version: number, displayName?: string | null }, spec: { __typename?: 'UserSpec', email: string, activeAccount: string } }> };

export type GetInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvitationsQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'Invitation', id: string, accountId: string, email?: string | null, createdAt: any, expiredAt: any, redeemedAt?: any | null, createdBy?: string | null, redeemedBy?: string | null, role: string, note?: string | null, status: InvitationStatus, link: string }> };

export type InvitationsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InvitationsSubscription = { __typename?: 'Subscription', invitations: Array<{ __typename?: 'Invitation', id: string }> };

export type GetAgentHealthQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  interval: Scalars['String']['input'];
}>;


export type GetAgentHealthQuery = { __typename?: 'Query', agentHealthMetrics: Array<{ __typename?: 'Metric', name?: string | null, timestamp?: any | null, value?: any | null, unit?: string | null, type?: string | null, attributes?: any | null, resource?: any | null } | null> };

export type GetConfigurationNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigurationNamesQuery = { __typename?: 'Query', configurations: { __typename?: 'Configurations', configurations: Array<{ __typename?: 'Configuration', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, labels?: any | null } }> } };

export type GetInstalledAgentsQueryVariables = Exact<{
  selector: Scalars['String']['input'];
}>;


export type GetInstalledAgentsQuery = { __typename?: 'Query', agents: { __typename?: 'Agents', agents: Array<{ __typename?: 'Agent', id: string, name: string, status: number, version?: string | null }> } };

export type GetAgentQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type GetAgentQuery = { __typename?: 'Query', agent?: { __typename?: 'Agent', id: string, name: string, architecture?: string | null, operatingSystem?: string | null, labels?: any | null, hostName?: string | null, platform?: string | null, version?: string | null, macAddress?: string | null, remoteAddress?: string | null, home?: string | null, status: number, connectedAt?: any | null, disconnectedAt?: any | null, errorMessage?: string | null, upgradeAvailable?: string | null, features: number, configuration?: { __typename?: 'AgentConfiguration', Collector?: string | null } | null, configurationResource?: { __typename?: 'Configuration', rendered?: string | null, metadata: { __typename?: 'Metadata', id: string, version: number, name: string } } | null, upgrade?: { __typename?: 'AgentUpgrade', status: number, version: string, error?: string | null } | null } | null };

export type GetAgentPageConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentPageConfigurationsQuery = { __typename?: 'Query', configurations: { __typename?: 'Configurations', configurations: Array<{ __typename?: 'Configuration', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, labels?: any | null }, spec: { __typename?: 'ConfigurationSpec', raw?: string | null } }> } };

export type AgentDetailsChangedSubscriptionVariables = Exact<{
  agentID?: InputMaybe<Scalars['String']['input']>;
}>;


export type AgentDetailsChangedSubscription = { __typename?: 'Subscription', agentDetailsChanged?: boolean | null };

export type GetUsernamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsernamesQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null } }> };

export type GetAuditEventsQueryVariables = Exact<{
  options?: InputMaybe<AuditEventFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuditEventsQuery = { __typename?: 'Query', auditEvents: Array<{ __typename?: 'AuditEvent', id: string, timestamp?: any | null, resourceName: string, resourceKind: string, configuration?: string | null, action?: AuditEventAction | null, user: string, account?: string | null, description: string }> };

export type GetConfigRolloutAgentsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetConfigRolloutAgentsQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', agentCount?: number | null, metadata: { __typename?: 'Metadata', name: string, id: string, version: number } } | null };

export type GetRenderedConfigValueQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetRenderedConfigValueQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', rendered?: string | null, metadata: { __typename?: 'Metadata', name: string, id: string, version: number } } | null };

export type GetConfigurationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetConfigurationQuery = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', agentCount?: number | null, metadata: { __typename?: 'Metadata', id: string, name: string, description?: string | null, labels?: any | null, version: number }, spec: { __typename?: 'ConfigurationSpec', measurementInterval?: string | null, raw?: string | null, sources?: Array<{ __typename?: 'ResourceConfiguration', id?: string | null, type?: string | null, name?: string | null, displayName?: string | null, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null, processors?: Array<{ __typename?: 'ResourceConfiguration', id?: string | null, type?: string | null, name?: string | null, displayName?: string | null, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null }> | null }> | null, destinations?: Array<{ __typename?: 'ResourceConfiguration', id?: string | null, type?: string | null, name?: string | null, displayName?: string | null, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null, processors?: Array<{ __typename?: 'ResourceConfiguration', id?: string | null, type?: string | null, name?: string | null, displayName?: string | null, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null }> | null }> | null, extensions?: Array<{ __typename?: 'ResourceConfiguration', id?: string | null, type?: string | null, name?: string | null, displayName?: string | null, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null }> | null, selector?: { __typename?: 'AgentSelector', matchLabels?: any | null } | null }, graph?: { __typename?: 'Graph', attributes: any, sources: Array<{ __typename?: 'Node', id: string, type: string, label: string, attributes: any }>, intermediates: Array<{ __typename?: 'Node', id: string, type: string, label: string, attributes: any }>, targets: Array<{ __typename?: 'Node', id: string, type: string, label: string, attributes: any }>, edges: Array<{ __typename?: 'Edge', id: string, source: string, target: string }> } | null } | null };

export type DestinationsAndTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DestinationsAndTypesQuery = { __typename?: 'Query', destinationTypes: Array<{ __typename?: 'DestinationType', kind: string, apiVersion: string, metadata: { __typename?: 'Metadata', id: string, version: number, name: string, displayName?: string | null, deprecated?: boolean | null, description?: string | null, icon?: string | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', version: string, supportedPlatforms: Array<string>, telemetryTypes: Array<PipelineType>, parameters: Array<{ __typename?: 'ParameterDefinition', label: string, type: ParameterType, name: string, description: string, default?: any | null, validValues?: Array<string> | null, advancedConfig?: boolean | null, required: boolean, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, value: any, operator: RelevantIfOperatorType }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', creatable?: boolean | null, multiline?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } }>, destinations: Array<{ __typename?: 'Destination', metadata: { __typename?: 'Metadata', id: string, version: number, name: string }, spec: { __typename?: 'ParameterizedSpec', type: string, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } }> };

export type SourcesAndTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SourcesAndTypesQuery = { __typename?: 'Query', sourceTypes: Array<{ __typename?: 'SourceType', apiVersion: string, kind: string, metadata: { __typename?: 'Metadata', id: string, name: string, version: number, displayName?: string | null, description?: string | null, icon?: string | null, resourceDocLink?: string | null, additionalInfo?: { __typename?: 'AdditionalInfo', message: string, documentation: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> } | null }, spec: { __typename?: 'ResourceTypeSpec', supportedPlatforms: Array<string>, version: string, telemetryTypes: Array<PipelineType>, parameters: Array<{ __typename?: 'ParameterDefinition', name: string, label: string, description: string, advancedConfig?: boolean | null, required: boolean, type: ParameterType, validValues?: Array<string> | null, default?: any | null, relevantIf?: Array<{ __typename?: 'RelevantIfCondition', name: string, operator: RelevantIfOperatorType, value: any }> | null, documentation?: Array<{ __typename?: 'DocumentationLink', text: string, url: string }> | null, options: { __typename?: 'ParameterOptions', creatable?: boolean | null, multiline?: boolean | null, trackUnchecked?: boolean | null, sectionHeader?: boolean | null, subHeader?: string | null, horizontalDivider?: boolean | null, gridColumns?: number | null, labels?: any | null, password?: boolean | null, sensitive?: boolean | null, metricCategories?: Array<{ __typename?: 'MetricCategory', label: string, column: number, metrics: Array<{ __typename?: 'MetricOption', name: string, description?: string | null, kpi?: boolean | null }> }> | null } }> } }>, sources: Array<{ __typename?: 'Source', metadata: { __typename?: 'Metadata', id: string, version: number, name: string }, spec: { __typename?: 'ParameterizedSpec', type: string, disabled: boolean, parameters?: Array<{ __typename?: 'Parameter', name: string, value: any }> | null } }> };

export type GetConfigNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigNamesQuery = { __typename?: 'Query', configurations: { __typename?: 'Configurations', configurations: Array<{ __typename?: 'Configuration', metadata: { __typename?: 'Metadata', id: string, name: string, version: number } }> } };

export type DestinationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  filterUnused?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DestinationsQuery = { __typename?: 'Query', destinations: Array<{ __typename?: 'Destination', kind: string, metadata: { __typename?: 'Metadata', id: string, name: string, version: number }, spec: { __typename?: 'ParameterizedSpec', type: string } }> };

export type GetOverviewPageQueryVariables = Exact<{
  configIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetOverviewPageQuery = { __typename?: 'Query', overviewPage: { __typename?: 'OverviewPage', graph: { __typename?: 'Graph', attributes: any, sources: Array<{ __typename?: 'Node', id: string, label: string, type: string, attributes: any }>, intermediates: Array<{ __typename?: 'Node', id: string, label: string, type: string, attributes: any }>, targets: Array<{ __typename?: 'Node', id: string, label: string, type: string, attributes: any }>, edges: Array<{ __typename?: 'Edge', id: string, source: string, target: string }> } } };

export type DeployedConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type DeployedConfigsQuery = { __typename?: 'Query', configurations: { __typename?: 'Configurations', configurations: Array<{ __typename?: 'Configuration', metadata: { __typename?: 'Metadata', id: string, name: string, version: number } }> } };

export type OverviewPageMetricsSubscriptionVariables = Exact<{
  period: Scalars['String']['input'];
  configIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OverviewPageMetricsSubscription = { __typename?: 'Subscription', overviewMetrics: { __typename?: 'GraphMetrics', maxMetricValue: number, maxLogValue: number, maxTraceValue: number, metrics: Array<{ __typename?: 'GraphMetric', name: string, nodeID: string, pipelineType: string, value: number, unit: string }>, edgeMetrics: Array<{ __typename?: 'EdgeMetric', name: string, edgeID: string, unit: string, value: number, pipelineType: string }> } };

export type GetDestinationsSummaryDataQueryVariables = Exact<{
  period: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  telemetryType: Scalars['String']['input'];
}>;


export type GetDestinationsSummaryDataQuery = { __typename?: 'Query', destinationsSummary: Array<{ __typename?: 'DestinationsSummaryDataPoint', totalEgress: number, destinationName: string }> };

export type GetConfigurationMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigurationMetricsQuery = { __typename?: 'Query', configurationMetrics: { __typename?: 'GraphMetrics', metrics: Array<{ __typename?: 'GraphMetric', name: string, nodeID: string, pipelineType: string, value: number, unit: string }> } };

export type SourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type SourcesQuery = { __typename?: 'Query', sources: Array<{ __typename?: 'Source', metadata: { __typename?: 'Metadata', id: string, name: string, displayName?: string | null, version: number }, spec: { __typename?: 'ParameterizedSpec', type: string } }> };

export type ProcessorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessorsQuery = { __typename?: 'Query', processors: Array<{ __typename?: 'Processor', metadata: { __typename?: 'Metadata', id: string, name: string, displayName?: string | null, version: number }, spec: { __typename?: 'ParameterizedSpec', type: string } }> };


export const GetAgentMonitoringSummaryDocument = gql`
    query GetAgentMonitoringSummary {
  agentMonitoring {
    total
    disconnected
    errored
    outdated
    connected
  }
}
    `;

/**
 * __useGetAgentMonitoringSummaryQuery__
 *
 * To run a query within a React component, call `useGetAgentMonitoringSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentMonitoringSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentMonitoringSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentMonitoringSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentMonitoringSummaryQuery, GetAgentMonitoringSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentMonitoringSummaryQuery, GetAgentMonitoringSummaryQueryVariables>(GetAgentMonitoringSummaryDocument, options);
      }
export function useGetAgentMonitoringSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentMonitoringSummaryQuery, GetAgentMonitoringSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentMonitoringSummaryQuery, GetAgentMonitoringSummaryQueryVariables>(GetAgentMonitoringSummaryDocument, options);
        }
export type GetAgentMonitoringSummaryQueryHookResult = ReturnType<typeof useGetAgentMonitoringSummaryQuery>;
export type GetAgentMonitoringSummaryLazyQueryHookResult = ReturnType<typeof useGetAgentMonitoringSummaryLazyQuery>;
export type GetAgentMonitoringSummaryQueryResult = Apollo.QueryResult<GetAgentMonitoringSummaryQuery, GetAgentMonitoringSummaryQueryVariables>;
export const SourceTypeDocument = gql`
    query SourceType($name: String!) {
  sourceType(name: $name) {
    metadata {
      id
      name
      version
      displayName
      icon
      displayName
      description
      additionalInfo {
        message
        documentation {
          text
          url
        }
      }
      resourceDocLink
    }
    spec {
      parameters {
        label
        name
        description
        required
        type
        default
        documentation {
          text
          url
        }
        relevantIf {
          name
          operator
          value
        }
        advancedConfig
        validValues
        options {
          creatable
          trackUnchecked
          sectionHeader
          subHeader
          horizontalDivider
          gridColumns
          labels
          metricCategories {
            label
            column
            metrics {
              name
              description
              kpi
            }
          }
          password
          sensitive
        }
      }
    }
  }
}
    `;

/**
 * __useSourceTypeQuery__
 *
 * To run a query within a React component, call `useSourceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSourceTypeQuery(baseOptions: Apollo.QueryHookOptions<SourceTypeQuery, SourceTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceTypeQuery, SourceTypeQueryVariables>(SourceTypeDocument, options);
      }
export function useSourceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceTypeQuery, SourceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceTypeQuery, SourceTypeQueryVariables>(SourceTypeDocument, options);
        }
export type SourceTypeQueryHookResult = ReturnType<typeof useSourceTypeQuery>;
export type SourceTypeLazyQueryHookResult = ReturnType<typeof useSourceTypeLazyQuery>;
export type SourceTypeQueryResult = Apollo.QueryResult<SourceTypeQuery, SourceTypeQueryVariables>;
export const GetDestinationWithTypeDocument = gql`
    query getDestinationWithType($name: String!) {
  destinationWithType(name: $name) {
    destination {
      metadata {
        name
        version
        id
        labels
        version
      }
      spec {
        type
        parameters {
          name
          value
        }
        disabled
      }
    }
    destinationType {
      metadata {
        id
        name
        version
        icon
        description
        additionalInfo {
          message
          documentation {
            text
            url
          }
        }
        resourceDocLink
      }
      spec {
        parameters {
          label
          name
          description
          required
          type
          default
          relevantIf {
            name
            operator
            value
          }
          documentation {
            text
            url
          }
          advancedConfig
          validValues
          options {
            multiline
            creatable
            trackUnchecked
            sectionHeader
            subHeader
            horizontalDivider
            gridColumns
            labels
            metricCategories {
              label
              column
              metrics {
                name
                description
                kpi
              }
            }
            password
            sensitive
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDestinationWithTypeQuery__
 *
 * To run a query within a React component, call `useGetDestinationWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationWithTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetDestinationWithTypeQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationWithTypeQuery, GetDestinationWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationWithTypeQuery, GetDestinationWithTypeQueryVariables>(GetDestinationWithTypeDocument, options);
      }
export function useGetDestinationWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationWithTypeQuery, GetDestinationWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationWithTypeQuery, GetDestinationWithTypeQueryVariables>(GetDestinationWithTypeDocument, options);
        }
export type GetDestinationWithTypeQueryHookResult = ReturnType<typeof useGetDestinationWithTypeQuery>;
export type GetDestinationWithTypeLazyQueryHookResult = ReturnType<typeof useGetDestinationWithTypeLazyQuery>;
export type GetDestinationWithTypeQueryResult = Apollo.QueryResult<GetDestinationWithTypeQuery, GetDestinationWithTypeQueryVariables>;
export const GetSourceWithTypeDocument = gql`
    query getSourceWithType($name: String!) {
  sourceWithType(name: $name) {
    source {
      metadata {
        name
        version
        id
        labels
        version
        displayName
      }
      spec {
        type
        parameters {
          name
          value
        }
        disabled
      }
    }
    sourceType {
      metadata {
        id
        name
        version
        icon
        description
        additionalInfo {
          message
          documentation {
            text
            url
          }
        }
        resourceDocLink
      }
      spec {
        parameters {
          label
          name
          description
          required
          type
          default
          relevantIf {
            name
            operator
            value
          }
          documentation {
            text
            url
          }
          advancedConfig
          validValues
          options {
            multiline
            creatable
            trackUnchecked
            sectionHeader
            subHeader
            horizontalDivider
            gridColumns
            labels
            metricCategories {
              label
              column
              metrics {
                name
                description
                kpi
              }
            }
            password
            sensitive
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSourceWithTypeQuery__
 *
 * To run a query within a React component, call `useGetSourceWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceWithTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSourceWithTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSourceWithTypeQuery, GetSourceWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourceWithTypeQuery, GetSourceWithTypeQueryVariables>(GetSourceWithTypeDocument, options);
      }
export function useGetSourceWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourceWithTypeQuery, GetSourceWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourceWithTypeQuery, GetSourceWithTypeQueryVariables>(GetSourceWithTypeDocument, options);
        }
export type GetSourceWithTypeQueryHookResult = ReturnType<typeof useGetSourceWithTypeQuery>;
export type GetSourceWithTypeLazyQueryHookResult = ReturnType<typeof useGetSourceWithTypeLazyQuery>;
export type GetSourceWithTypeQueryResult = Apollo.QueryResult<GetSourceWithTypeQuery, GetSourceWithTypeQueryVariables>;
export const GetConfigurationExtensionsDocument = gql`
    query GetConfigurationExtensions($name: String!) {
  configuration(name: $name) {
    metadata {
      name
      id
      version
    }
    spec {
      extensions {
        name
        id
        type
      }
    }
  }
}
    `;

/**
 * __useGetConfigurationExtensionsQuery__
 *
 * To run a query within a React component, call `useGetConfigurationExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationExtensionsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetConfigurationExtensionsQuery(baseOptions: Apollo.QueryHookOptions<GetConfigurationExtensionsQuery, GetConfigurationExtensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationExtensionsQuery, GetConfigurationExtensionsQueryVariables>(GetConfigurationExtensionsDocument, options);
      }
export function useGetConfigurationExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationExtensionsQuery, GetConfigurationExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationExtensionsQuery, GetConfigurationExtensionsQueryVariables>(GetConfigurationExtensionsDocument, options);
        }
export type GetConfigurationExtensionsQueryHookResult = ReturnType<typeof useGetConfigurationExtensionsQuery>;
export type GetConfigurationExtensionsLazyQueryHookResult = ReturnType<typeof useGetConfigurationExtensionsLazyQuery>;
export type GetConfigurationExtensionsQueryResult = Apollo.QueryResult<GetConfigurationExtensionsQuery, GetConfigurationExtensionsQueryVariables>;
export const GetCurrentConfigVersionDocument = gql`
    query getCurrentConfigVersion($configurationName: String!) {
  configuration(name: $configurationName) {
    metadata {
      id
      name
      version
      labels
    }
    agentCount
  }
}
    `;

/**
 * __useGetCurrentConfigVersionQuery__
 *
 * To run a query within a React component, call `useGetCurrentConfigVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentConfigVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentConfigVersionQuery({
 *   variables: {
 *      configurationName: // value for 'configurationName'
 *   },
 * });
 */
export function useGetCurrentConfigVersionQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentConfigVersionQuery, GetCurrentConfigVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentConfigVersionQuery, GetCurrentConfigVersionQueryVariables>(GetCurrentConfigVersionDocument, options);
      }
export function useGetCurrentConfigVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentConfigVersionQuery, GetCurrentConfigVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentConfigVersionQuery, GetCurrentConfigVersionQueryVariables>(GetCurrentConfigVersionDocument, options);
        }
export type GetCurrentConfigVersionQueryHookResult = ReturnType<typeof useGetCurrentConfigVersionQuery>;
export type GetCurrentConfigVersionLazyQueryHookResult = ReturnType<typeof useGetCurrentConfigVersionLazyQuery>;
export type GetCurrentConfigVersionQueryResult = Apollo.QueryResult<GetCurrentConfigVersionQuery, GetCurrentConfigVersionQueryVariables>;
export const GetLatestConfigDescriptionDocument = gql`
    query getLatestConfigDescription($configurationName: String!) {
  configuration(name: $configurationName) {
    metadata {
      id
      name
      version
      description
      labels
    }
  }
}
    `;

/**
 * __useGetLatestConfigDescriptionQuery__
 *
 * To run a query within a React component, call `useGetLatestConfigDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestConfigDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestConfigDescriptionQuery({
 *   variables: {
 *      configurationName: // value for 'configurationName'
 *   },
 * });
 */
export function useGetLatestConfigDescriptionQuery(baseOptions: Apollo.QueryHookOptions<GetLatestConfigDescriptionQuery, GetLatestConfigDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestConfigDescriptionQuery, GetLatestConfigDescriptionQueryVariables>(GetLatestConfigDescriptionDocument, options);
      }
export function useGetLatestConfigDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestConfigDescriptionQuery, GetLatestConfigDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestConfigDescriptionQuery, GetLatestConfigDescriptionQueryVariables>(GetLatestConfigDescriptionDocument, options);
        }
export type GetLatestConfigDescriptionQueryHookResult = ReturnType<typeof useGetLatestConfigDescriptionQuery>;
export type GetLatestConfigDescriptionLazyQueryHookResult = ReturnType<typeof useGetLatestConfigDescriptionLazyQuery>;
export type GetLatestConfigDescriptionQueryResult = Apollo.QueryResult<GetLatestConfigDescriptionQuery, GetLatestConfigDescriptionQueryVariables>;
export const EditConfigDescriptionDocument = gql`
    mutation editConfigDescription($input: EditConfigurationDescriptionInput!) {
  editConfigurationDescription(input: $input)
}
    `;
export type EditConfigDescriptionMutationFn = Apollo.MutationFunction<EditConfigDescriptionMutation, EditConfigDescriptionMutationVariables>;

/**
 * __useEditConfigDescriptionMutation__
 *
 * To run a mutation, you first call `useEditConfigDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditConfigDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editConfigDescriptionMutation, { data, loading, error }] = useEditConfigDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditConfigDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<EditConfigDescriptionMutation, EditConfigDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditConfigDescriptionMutation, EditConfigDescriptionMutationVariables>(EditConfigDescriptionDocument, options);
      }
export type EditConfigDescriptionMutationHookResult = ReturnType<typeof useEditConfigDescriptionMutation>;
export type EditConfigDescriptionMutationResult = Apollo.MutationResult<EditConfigDescriptionMutation>;
export type EditConfigDescriptionMutationOptions = Apollo.BaseMutationOptions<EditConfigDescriptionMutation, EditConfigDescriptionMutationVariables>;
export const GetConfigurationVersionsDocument = gql`
    query getConfigurationVersions($name: String!) {
  configurationVersions(name: $name) {
    metadata {
      name
      id
      version
    }
    activeTypes
    status {
      current
      pending
      latest
    }
  }
}
    `;

/**
 * __useGetConfigurationVersionsQuery__
 *
 * To run a query within a React component, call `useGetConfigurationVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationVersionsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetConfigurationVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetConfigurationVersionsQuery, GetConfigurationVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationVersionsQuery, GetConfigurationVersionsQueryVariables>(GetConfigurationVersionsDocument, options);
      }
export function useGetConfigurationVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationVersionsQuery, GetConfigurationVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationVersionsQuery, GetConfigurationVersionsQueryVariables>(GetConfigurationVersionsDocument, options);
        }
export type GetConfigurationVersionsQueryHookResult = ReturnType<typeof useGetConfigurationVersionsQuery>;
export type GetConfigurationVersionsLazyQueryHookResult = ReturnType<typeof useGetConfigurationVersionsLazyQuery>;
export type GetConfigurationVersionsQueryResult = Apollo.QueryResult<GetConfigurationVersionsQuery, GetConfigurationVersionsQueryVariables>;
export const GetLatestMeasurementIntervalDocument = gql`
    query getLatestMeasurementInterval($name: String!) {
  configuration(name: $name) {
    metadata {
      name
      id
      version
    }
    spec {
      measurementInterval
    }
  }
}
    `;

/**
 * __useGetLatestMeasurementIntervalQuery__
 *
 * To run a query within a React component, call `useGetLatestMeasurementIntervalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeasurementIntervalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeasurementIntervalQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetLatestMeasurementIntervalQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeasurementIntervalQuery, GetLatestMeasurementIntervalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeasurementIntervalQuery, GetLatestMeasurementIntervalQueryVariables>(GetLatestMeasurementIntervalDocument, options);
      }
export function useGetLatestMeasurementIntervalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeasurementIntervalQuery, GetLatestMeasurementIntervalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeasurementIntervalQuery, GetLatestMeasurementIntervalQueryVariables>(GetLatestMeasurementIntervalDocument, options);
        }
export type GetLatestMeasurementIntervalQueryHookResult = ReturnType<typeof useGetLatestMeasurementIntervalQuery>;
export type GetLatestMeasurementIntervalLazyQueryHookResult = ReturnType<typeof useGetLatestMeasurementIntervalLazyQuery>;
export type GetLatestMeasurementIntervalQueryResult = Apollo.QueryResult<GetLatestMeasurementIntervalQuery, GetLatestMeasurementIntervalQueryVariables>;
export const GetConfigurationMonitoringSummaryDocument = gql`
    query GetConfigurationMonitoringSummary {
  configurationMonitoring {
    total
    errored
    pending
  }
}
    `;

/**
 * __useGetConfigurationMonitoringSummaryQuery__
 *
 * To run a query within a React component, call `useGetConfigurationMonitoringSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationMonitoringSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationMonitoringSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationMonitoringSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationMonitoringSummaryQuery, GetConfigurationMonitoringSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationMonitoringSummaryQuery, GetConfigurationMonitoringSummaryQueryVariables>(GetConfigurationMonitoringSummaryDocument, options);
      }
export function useGetConfigurationMonitoringSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationMonitoringSummaryQuery, GetConfigurationMonitoringSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationMonitoringSummaryQuery, GetConfigurationMonitoringSummaryQueryVariables>(GetConfigurationMonitoringSummaryDocument, options);
        }
export type GetConfigurationMonitoringSummaryQueryHookResult = ReturnType<typeof useGetConfigurationMonitoringSummaryQuery>;
export type GetConfigurationMonitoringSummaryLazyQueryHookResult = ReturnType<typeof useGetConfigurationMonitoringSummaryLazyQuery>;
export type GetConfigurationMonitoringSummaryQueryResult = Apollo.QueryResult<GetConfigurationMonitoringSummaryQuery, GetConfigurationMonitoringSummaryQueryVariables>;
export const GetConfigurationSummaryDocument = gql`
    query GetConfigurationSummary($period: String!, $interval: String!, $telemetryType: String!) {
  configurationSummary(
    period: $period
    interval: $interval
    telemetryType: $telemetryType
  ) {
    name
    totalIngest
    totalEgress
    dataset {
      timestamp
      s0Value
      d1Value
    }
  }
}
    `;

/**
 * __useGetConfigurationSummaryQuery__
 *
 * To run a query within a React component, call `useGetConfigurationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationSummaryQuery({
 *   variables: {
 *      period: // value for 'period'
 *      interval: // value for 'interval'
 *      telemetryType: // value for 'telemetryType'
 *   },
 * });
 */
export function useGetConfigurationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetConfigurationSummaryQuery, GetConfigurationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationSummaryQuery, GetConfigurationSummaryQueryVariables>(GetConfigurationSummaryDocument, options);
      }
export function useGetConfigurationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationSummaryQuery, GetConfigurationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationSummaryQuery, GetConfigurationSummaryQueryVariables>(GetConfigurationSummaryDocument, options);
        }
export type GetConfigurationSummaryQueryHookResult = ReturnType<typeof useGetConfigurationSummaryQuery>;
export type GetConfigurationSummaryLazyQueryHookResult = ReturnType<typeof useGetConfigurationSummaryLazyQuery>;
export type GetConfigurationSummaryQueryResult = Apollo.QueryResult<GetConfigurationSummaryQuery, GetConfigurationSummaryQueryVariables>;
export const GetSummaryGraphDocument = gql`
    query GetSummaryGraph($period: String!, $interval: String!, $telemetryType: String!, $destinationIDs: [ID!]) {
  summaryGraphData(
    period: $period
    interval: $interval
    telemetryType: $telemetryType
    destinationIDs: $destinationIDs
  ) {
    totalIngest
    totalEgress
    dataset {
      timestamp
      s0Value
      d1Value
    }
  }
}
    `;

/**
 * __useGetSummaryGraphQuery__
 *
 * To run a query within a React component, call `useGetSummaryGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummaryGraphQuery({
 *   variables: {
 *      period: // value for 'period'
 *      interval: // value for 'interval'
 *      telemetryType: // value for 'telemetryType'
 *      destinationIDs: // value for 'destinationIDs'
 *   },
 * });
 */
export function useGetSummaryGraphQuery(baseOptions: Apollo.QueryHookOptions<GetSummaryGraphQuery, GetSummaryGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSummaryGraphQuery, GetSummaryGraphQueryVariables>(GetSummaryGraphDocument, options);
      }
export function useGetSummaryGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSummaryGraphQuery, GetSummaryGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSummaryGraphQuery, GetSummaryGraphQueryVariables>(GetSummaryGraphDocument, options);
        }
export type GetSummaryGraphQueryHookResult = ReturnType<typeof useGetSummaryGraphQuery>;
export type GetSummaryGraphLazyQueryHookResult = ReturnType<typeof useGetSummaryGraphLazyQuery>;
export type GetSummaryGraphQueryResult = Apollo.QueryResult<GetSummaryGraphQuery, GetSummaryGraphQueryVariables>;
export const SummaryGraphDataDocument = gql`
    subscription SummaryGraphData($period: String!, $interval: String!, $telemetryType: String!, $destinationIDs: [ID!]) {
  summaryGraphData(
    period: $period
    interval: $interval
    telemetryType: $telemetryType
    destinationIDs: $destinationIDs
  ) {
    totalIngest
    totalEgress
    dataset {
      timestamp
      s0Value
      d1Value
    }
  }
}
    `;

/**
 * __useSummaryGraphDataSubscription__
 *
 * To run a query within a React component, call `useSummaryGraphDataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSummaryGraphDataSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryGraphDataSubscription({
 *   variables: {
 *      period: // value for 'period'
 *      interval: // value for 'interval'
 *      telemetryType: // value for 'telemetryType'
 *      destinationIDs: // value for 'destinationIDs'
 *   },
 * });
 */
export function useSummaryGraphDataSubscription(baseOptions: Apollo.SubscriptionHookOptions<SummaryGraphDataSubscription, SummaryGraphDataSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SummaryGraphDataSubscription, SummaryGraphDataSubscriptionVariables>(SummaryGraphDataDocument, options);
      }
export type SummaryGraphDataSubscriptionHookResult = ReturnType<typeof useSummaryGraphDataSubscription>;
export type SummaryGraphDataSubscriptionResult = Apollo.SubscriptionResult<SummaryGraphDataSubscription>;
export const GetRenderedConfigDocument = gql`
    query getRenderedConfig($name: String!) {
  configuration(name: $name) {
    metadata {
      name
      id
      version
    }
    rendered
  }
}
    `;

/**
 * __useGetRenderedConfigQuery__
 *
 * To run a query within a React component, call `useGetRenderedConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderedConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderedConfigQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRenderedConfigQuery(baseOptions: Apollo.QueryHookOptions<GetRenderedConfigQuery, GetRenderedConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderedConfigQuery, GetRenderedConfigQueryVariables>(GetRenderedConfigDocument, options);
      }
export function useGetRenderedConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderedConfigQuery, GetRenderedConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderedConfigQuery, GetRenderedConfigQueryVariables>(GetRenderedConfigDocument, options);
        }
export type GetRenderedConfigQueryHookResult = ReturnType<typeof useGetRenderedConfigQuery>;
export type GetRenderedConfigLazyQueryHookResult = ReturnType<typeof useGetRenderedConfigLazyQuery>;
export type GetRenderedConfigQueryResult = Apollo.QueryResult<GetRenderedConfigQuery, GetRenderedConfigQueryVariables>;
export const GetVersionHistoryDocument = gql`
    query getVersionHistory($name: String!) {
  configurationHistory(name: $name) {
    metadata {
      name
      id
      version
    }
    status {
      current
      pending
      latest
    }
  }
}
    `;

/**
 * __useGetVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionHistoryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetVersionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetVersionHistoryQuery, GetVersionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVersionHistoryQuery, GetVersionHistoryQueryVariables>(GetVersionHistoryDocument, options);
      }
export function useGetVersionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVersionHistoryQuery, GetVersionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVersionHistoryQuery, GetVersionHistoryQueryVariables>(GetVersionHistoryDocument, options);
        }
export type GetVersionHistoryQueryHookResult = ReturnType<typeof useGetVersionHistoryQuery>;
export type GetVersionHistoryLazyQueryHookResult = ReturnType<typeof useGetVersionHistoryLazyQuery>;
export type GetVersionHistoryQueryResult = Apollo.QueryResult<GetVersionHistoryQuery, GetVersionHistoryQueryVariables>;
export const PaginatedAgentsTableDocument = gql`
    query PaginatedAgentsTable($options: AgentsTableOptions!) {
  agentsTable(options: $options) {
    agents {
      id
      labels
      version
      name
      status
      operatingSystem
      configurationStatus {
        current
      }
    }
    agentCount
    query
    suggestions {
      query
      label
    }
    latestVersion
    agentMetrics {
      name
      nodeID
      unit
      value
      agentID
      pipelineType
    }
  }
}
    `;

/**
 * __usePaginatedAgentsTableQuery__
 *
 * To run a query within a React component, call `usePaginatedAgentsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAgentsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAgentsTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePaginatedAgentsTableQuery(baseOptions: Apollo.QueryHookOptions<PaginatedAgentsTableQuery, PaginatedAgentsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedAgentsTableQuery, PaginatedAgentsTableQueryVariables>(PaginatedAgentsTableDocument, options);
      }
export function usePaginatedAgentsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedAgentsTableQuery, PaginatedAgentsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedAgentsTableQuery, PaginatedAgentsTableQueryVariables>(PaginatedAgentsTableDocument, options);
        }
export type PaginatedAgentsTableQueryHookResult = ReturnType<typeof usePaginatedAgentsTableQuery>;
export type PaginatedAgentsTableLazyQueryHookResult = ReturnType<typeof usePaginatedAgentsTableLazyQuery>;
export type PaginatedAgentsTableQueryResult = Apollo.QueryResult<PaginatedAgentsTableQuery, PaginatedAgentsTableQueryVariables>;
export const AgentsTableChangedDocument = gql`
    subscription AgentsTableChanged($agentIDs: [String!]!, $selector: String) {
  agentsTableChanged(agentIDs: $agentIDs, selector: $selector)
}
    `;

/**
 * __useAgentsTableChangedSubscription__
 *
 * To run a query within a React component, call `useAgentsTableChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentsTableChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsTableChangedSubscription({
 *   variables: {
 *      agentIDs: // value for 'agentIDs'
 *      selector: // value for 'selector'
 *   },
 * });
 */
export function useAgentsTableChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AgentsTableChangedSubscription, AgentsTableChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgentsTableChangedSubscription, AgentsTableChangedSubscriptionVariables>(AgentsTableChangedDocument, options);
      }
export type AgentsTableChangedSubscriptionHookResult = ReturnType<typeof useAgentsTableChangedSubscription>;
export type AgentsTableChangedSubscriptionResult = Apollo.SubscriptionResult<AgentsTableChangedSubscription>;
export const ProcessorDialogSourceTypeDocument = gql`
    query processorDialogSourceType($name: String!) {
  sourceType(name: $name) {
    metadata {
      name
      id
      version
      displayName
      description
    }
    spec {
      telemetryTypes
    }
  }
}
    `;

/**
 * __useProcessorDialogSourceTypeQuery__
 *
 * To run a query within a React component, call `useProcessorDialogSourceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorDialogSourceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorDialogSourceTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProcessorDialogSourceTypeQuery(baseOptions: Apollo.QueryHookOptions<ProcessorDialogSourceTypeQuery, ProcessorDialogSourceTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorDialogSourceTypeQuery, ProcessorDialogSourceTypeQueryVariables>(ProcessorDialogSourceTypeDocument, options);
      }
export function useProcessorDialogSourceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorDialogSourceTypeQuery, ProcessorDialogSourceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorDialogSourceTypeQuery, ProcessorDialogSourceTypeQueryVariables>(ProcessorDialogSourceTypeDocument, options);
        }
export type ProcessorDialogSourceTypeQueryHookResult = ReturnType<typeof useProcessorDialogSourceTypeQuery>;
export type ProcessorDialogSourceTypeLazyQueryHookResult = ReturnType<typeof useProcessorDialogSourceTypeLazyQuery>;
export type ProcessorDialogSourceTypeQueryResult = Apollo.QueryResult<ProcessorDialogSourceTypeQuery, ProcessorDialogSourceTypeQueryVariables>;
export const ProcessorDialogDestinationTypeDocument = gql`
    query processorDialogDestinationType($name: String!) {
  destinationWithType(name: $name) {
    destinationType {
      metadata {
        id
        name
        version
        displayName
        description
      }
      spec {
        telemetryTypes
      }
    }
  }
}
    `;

/**
 * __useProcessorDialogDestinationTypeQuery__
 *
 * To run a query within a React component, call `useProcessorDialogDestinationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorDialogDestinationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorDialogDestinationTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProcessorDialogDestinationTypeQuery(baseOptions: Apollo.QueryHookOptions<ProcessorDialogDestinationTypeQuery, ProcessorDialogDestinationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorDialogDestinationTypeQuery, ProcessorDialogDestinationTypeQueryVariables>(ProcessorDialogDestinationTypeDocument, options);
      }
export function useProcessorDialogDestinationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorDialogDestinationTypeQuery, ProcessorDialogDestinationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorDialogDestinationTypeQuery, ProcessorDialogDestinationTypeQueryVariables>(ProcessorDialogDestinationTypeDocument, options);
        }
export type ProcessorDialogDestinationTypeQueryHookResult = ReturnType<typeof useProcessorDialogDestinationTypeQuery>;
export type ProcessorDialogDestinationTypeLazyQueryHookResult = ReturnType<typeof useProcessorDialogDestinationTypeLazyQuery>;
export type ProcessorDialogDestinationTypeQueryResult = Apollo.QueryResult<ProcessorDialogDestinationTypeQuery, ProcessorDialogDestinationTypeQueryVariables>;
export const UpdateProcessorsDocument = gql`
    mutation updateProcessors($input: UpdateProcessorsInput!) {
  updateProcessors(input: $input)
}
    `;
export type UpdateProcessorsMutationFn = Apollo.MutationFunction<UpdateProcessorsMutation, UpdateProcessorsMutationVariables>;

/**
 * __useUpdateProcessorsMutation__
 *
 * To run a mutation, you first call `useUpdateProcessorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessorsMutation, { data, loading, error }] = useUpdateProcessorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcessorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessorsMutation, UpdateProcessorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessorsMutation, UpdateProcessorsMutationVariables>(UpdateProcessorsDocument, options);
      }
export type UpdateProcessorsMutationHookResult = ReturnType<typeof useUpdateProcessorsMutation>;
export type UpdateProcessorsMutationResult = Apollo.MutationResult<UpdateProcessorsMutation>;
export type UpdateProcessorsMutationOptions = Apollo.BaseMutationOptions<UpdateProcessorsMutation, UpdateProcessorsMutationVariables>;
export const GetUserInfoDocument = gql`
    query getUserInfo {
  user {
    metadata {
      id
      name
      version
      displayName
    }
    spec {
      activeAccount
    }
  }
  accounts {
    metadata {
      id
      name
      version
      displayName
    }
  }
}
    `;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoQueryResult = Apollo.QueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const ChangeAccountDocument = gql`
    mutation changeAccount($input: ChangeAccountInput!) {
  changeAccount(input: $input) {
    metadata {
      name
      id
      version
      displayName
    }
    spec {
      activeAccount
    }
  }
}
    `;
export type ChangeAccountMutationFn = Apollo.MutationFunction<ChangeAccountMutation, ChangeAccountMutationVariables>;

/**
 * __useChangeAccountMutation__
 *
 * To run a mutation, you first call `useChangeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAccountMutation, { data, loading, error }] = useChangeAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeAccountMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAccountMutation, ChangeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAccountMutation, ChangeAccountMutationVariables>(ChangeAccountDocument, options);
      }
export type ChangeAccountMutationHookResult = ReturnType<typeof useChangeAccountMutation>;
export type ChangeAccountMutationResult = Apollo.MutationResult<ChangeAccountMutation>;
export type ChangeAccountMutationOptions = Apollo.BaseMutationOptions<ChangeAccountMutation, ChangeAccountMutationVariables>;
export const GetFeatureGateDocument = gql`
    query getFeatureGate($input: String!) {
  enabled: featureGate(id: $input)
}
    `;

/**
 * __useGetFeatureGateQuery__
 *
 * To run a query within a React component, call `useGetFeatureGateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureGateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeatureGateQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureGateQuery, GetFeatureGateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureGateQuery, GetFeatureGateQueryVariables>(GetFeatureGateDocument, options);
      }
export function useGetFeatureGateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureGateQuery, GetFeatureGateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureGateQuery, GetFeatureGateQueryVariables>(GetFeatureGateDocument, options);
        }
export type GetFeatureGateQueryHookResult = ReturnType<typeof useGetFeatureGateQuery>;
export type GetFeatureGateLazyQueryHookResult = ReturnType<typeof useGetFeatureGateLazyQuery>;
export type GetFeatureGateQueryResult = Apollo.QueryResult<GetFeatureGateQuery, GetFeatureGateQueryVariables>;
export const EditUserRoleDocument = gql`
    mutation EditUserRole($input: EditUserRoleInput!) {
  editRole(input: $input) {
    metadata {
      name
      id
      version
      displayName
    }
    spec {
      activeAccount
      email
    }
    role
  }
}
    `;
export type EditUserRoleMutationFn = Apollo.MutationFunction<EditUserRoleMutation, EditUserRoleMutationVariables>;

/**
 * __useEditUserRoleMutation__
 *
 * To run a mutation, you first call `useEditUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserRoleMutation, { data, loading, error }] = useEditUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<EditUserRoleMutation, EditUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserRoleMutation, EditUserRoleMutationVariables>(EditUserRoleDocument, options);
      }
export type EditUserRoleMutationHookResult = ReturnType<typeof useEditUserRoleMutation>;
export type EditUserRoleMutationResult = Apollo.MutationResult<EditUserRoleMutation>;
export type EditUserRoleMutationOptions = Apollo.BaseMutationOptions<EditUserRoleMutation, EditUserRoleMutationVariables>;
export const DeleteInvitationDocument = gql`
    mutation deleteInvitation($input: DeleteInvitationInput!) {
  deleteInvitation(input: $input)
}
    `;
export type DeleteInvitationMutationFn = Apollo.MutationFunction<DeleteInvitationMutation, DeleteInvitationMutationVariables>;

/**
 * __useDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvitationMutation, DeleteInvitationMutationVariables>(DeleteInvitationDocument, options);
      }
export type DeleteInvitationMutationHookResult = ReturnType<typeof useDeleteInvitationMutation>;
export type DeleteInvitationMutationResult = Apollo.MutationResult<DeleteInvitationMutation>;
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>;
export const NewInvitationDocument = gql`
    mutation newInvitation($input: NewInvitationInput) {
  newInvitation(input: $input) {
    id
    accountId
    createdAt
    redeemedAt
    redeemedBy
    link
  }
}
    `;
export type NewInvitationMutationFn = Apollo.MutationFunction<NewInvitationMutation, NewInvitationMutationVariables>;

/**
 * __useNewInvitationMutation__
 *
 * To run a mutation, you first call `useNewInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newInvitationMutation, { data, loading, error }] = useNewInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewInvitationMutation(baseOptions?: Apollo.MutationHookOptions<NewInvitationMutation, NewInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewInvitationMutation, NewInvitationMutationVariables>(NewInvitationDocument, options);
      }
export type NewInvitationMutationHookResult = ReturnType<typeof useNewInvitationMutation>;
export type NewInvitationMutationResult = Apollo.MutationResult<NewInvitationMutation>;
export type NewInvitationMutationOptions = Apollo.BaseMutationOptions<NewInvitationMutation, NewInvitationMutationVariables>;
export const RemoveAgentConfigurationDocument = gql`
    mutation removeAgentConfiguration($input: RemoveAgentConfigurationInput!) {
  removeAgentConfiguration(input: $input) {
    id
    configurationResource {
      rendered
    }
  }
}
    `;
export type RemoveAgentConfigurationMutationFn = Apollo.MutationFunction<RemoveAgentConfigurationMutation, RemoveAgentConfigurationMutationVariables>;

/**
 * __useRemoveAgentConfigurationMutation__
 *
 * To run a mutation, you first call `useRemoveAgentConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAgentConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAgentConfigurationMutation, { data, loading, error }] = useRemoveAgentConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAgentConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAgentConfigurationMutation, RemoveAgentConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAgentConfigurationMutation, RemoveAgentConfigurationMutationVariables>(RemoveAgentConfigurationDocument, options);
      }
export type RemoveAgentConfigurationMutationHookResult = ReturnType<typeof useRemoveAgentConfigurationMutation>;
export type RemoveAgentConfigurationMutationResult = Apollo.MutationResult<RemoveAgentConfigurationMutation>;
export type RemoveAgentConfigurationMutationOptions = Apollo.BaseMutationOptions<RemoveAgentConfigurationMutation, RemoveAgentConfigurationMutationVariables>;
export const PreviewFeatureGateDocument = gql`
    query PreviewFeatureGate {
  featureGate(id: "realtime-processor-preview")
}
    `;

/**
 * __usePreviewFeatureGateQuery__
 *
 * To run a query within a React component, call `usePreviewFeatureGateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewFeatureGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewFeatureGateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreviewFeatureGateQuery(baseOptions?: Apollo.QueryHookOptions<PreviewFeatureGateQuery, PreviewFeatureGateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewFeatureGateQuery, PreviewFeatureGateQueryVariables>(PreviewFeatureGateDocument, options);
      }
export function usePreviewFeatureGateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewFeatureGateQuery, PreviewFeatureGateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewFeatureGateQuery, PreviewFeatureGateQueryVariables>(PreviewFeatureGateDocument, options);
        }
export type PreviewFeatureGateQueryHookResult = ReturnType<typeof usePreviewFeatureGateQuery>;
export type PreviewFeatureGateLazyQueryHookResult = ReturnType<typeof usePreviewFeatureGateLazyQuery>;
export type PreviewFeatureGateQueryResult = Apollo.QueryResult<PreviewFeatureGateQuery, PreviewFeatureGateQueryVariables>;
export const ConfigurationMetricsDocument = gql`
    subscription ConfigurationMetrics($period: String!, $name: String!, $agent: String) {
  configurationMetrics(period: $period, name: $name, agent: $agent) {
    metrics {
      name
      nodeID
      pipelineType
      value
      unit
    }
    maxMetricValue
    maxLogValue
    maxTraceValue
  }
}
    `;

/**
 * __useConfigurationMetricsSubscription__
 *
 * To run a query within a React component, call `useConfigurationMetricsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationMetricsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationMetricsSubscription({
 *   variables: {
 *      period: // value for 'period'
 *      name: // value for 'name'
 *      agent: // value for 'agent'
 *   },
 * });
 */
export function useConfigurationMetricsSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConfigurationMetricsSubscription, ConfigurationMetricsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConfigurationMetricsSubscription, ConfigurationMetricsSubscriptionVariables>(ConfigurationMetricsDocument, options);
      }
export type ConfigurationMetricsSubscriptionHookResult = ReturnType<typeof useConfigurationMetricsSubscription>;
export type ConfigurationMetricsSubscriptionResult = Apollo.SubscriptionResult<ConfigurationMetricsSubscription>;
export const ProcessorsWithParamsDocument = gql`
    query ProcessorsWithParams {
  processors {
    metadata {
      id
      version
      name
    }
    spec {
      type
      parameters {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useProcessorsWithParamsQuery__
 *
 * To run a query within a React component, call `useProcessorsWithParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorsWithParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorsWithParamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessorsWithParamsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorsWithParamsQuery, ProcessorsWithParamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorsWithParamsQuery, ProcessorsWithParamsQueryVariables>(ProcessorsWithParamsDocument, options);
      }
export function useProcessorsWithParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorsWithParamsQuery, ProcessorsWithParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorsWithParamsQuery, ProcessorsWithParamsQueryVariables>(ProcessorsWithParamsDocument, options);
        }
export type ProcessorsWithParamsQueryHookResult = ReturnType<typeof useProcessorsWithParamsQuery>;
export type ProcessorsWithParamsLazyQueryHookResult = ReturnType<typeof useProcessorsWithParamsLazyQuery>;
export type ProcessorsWithParamsQueryResult = Apollo.QueryResult<ProcessorsWithParamsQuery, ProcessorsWithParamsQueryVariables>;
export const GetRolloutHistoryDocument = gql`
    query getRolloutHistory($name: String!) {
  configurationHistory(name: $name) {
    metadata {
      name
      id
      version
      dateModified
    }
    status {
      rollout {
        status
        errors
        startedAt
      }
    }
  }
}
    `;

/**
 * __useGetRolloutHistoryQuery__
 *
 * To run a query within a React component, call `useGetRolloutHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolloutHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolloutHistoryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRolloutHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetRolloutHistoryQuery, GetRolloutHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolloutHistoryQuery, GetRolloutHistoryQueryVariables>(GetRolloutHistoryDocument, options);
      }
export function useGetRolloutHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolloutHistoryQuery, GetRolloutHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolloutHistoryQuery, GetRolloutHistoryQueryVariables>(GetRolloutHistoryDocument, options);
        }
export type GetRolloutHistoryQueryHookResult = ReturnType<typeof useGetRolloutHistoryQuery>;
export type GetRolloutHistoryLazyQueryHookResult = ReturnType<typeof useGetRolloutHistoryLazyQuery>;
export type GetRolloutHistoryQueryResult = Apollo.QueryResult<GetRolloutHistoryQuery, GetRolloutHistoryQueryVariables>;
export const GetConfigRolloutStatusDocument = gql`
    query getConfigRolloutStatus($name: String!) {
  configuration(name: $name) {
    metadata {
      name
      id
      version
      dateModified
    }
    agentCount
    status {
      pending
      current
      latest
      rollout {
        status
        phase
        completed
        errors
        pending
        waiting
      }
    }
  }
}
    `;

/**
 * __useGetConfigRolloutStatusQuery__
 *
 * To run a query within a React component, call `useGetConfigRolloutStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigRolloutStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigRolloutStatusQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetConfigRolloutStatusQuery(baseOptions: Apollo.QueryHookOptions<GetConfigRolloutStatusQuery, GetConfigRolloutStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigRolloutStatusQuery, GetConfigRolloutStatusQueryVariables>(GetConfigRolloutStatusDocument, options);
      }
export function useGetConfigRolloutStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigRolloutStatusQuery, GetConfigRolloutStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigRolloutStatusQuery, GetConfigRolloutStatusQueryVariables>(GetConfigRolloutStatusDocument, options);
        }
export type GetConfigRolloutStatusQueryHookResult = ReturnType<typeof useGetConfigRolloutStatusQuery>;
export type GetConfigRolloutStatusLazyQueryHookResult = ReturnType<typeof useGetConfigRolloutStatusLazyQuery>;
export type GetConfigRolloutStatusQueryResult = Apollo.QueryResult<GetConfigRolloutStatusQuery, GetConfigRolloutStatusQueryVariables>;
export const AgentsWithConfigurationDocument = gql`
    query agentsWithConfiguration($selector: String, $query: String) {
  agents(selector: $selector, query: $query) {
    agents {
      id
      name
    }
  }
}
    `;

/**
 * __useAgentsWithConfigurationQuery__
 *
 * To run a query within a React component, call `useAgentsWithConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsWithConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsWithConfigurationQuery({
 *   variables: {
 *      selector: // value for 'selector'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAgentsWithConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<AgentsWithConfigurationQuery, AgentsWithConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsWithConfigurationQuery, AgentsWithConfigurationQueryVariables>(AgentsWithConfigurationDocument, options);
      }
export function useAgentsWithConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsWithConfigurationQuery, AgentsWithConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsWithConfigurationQuery, AgentsWithConfigurationQueryVariables>(AgentsWithConfigurationDocument, options);
        }
export type AgentsWithConfigurationQueryHookResult = ReturnType<typeof useAgentsWithConfigurationQuery>;
export type AgentsWithConfigurationLazyQueryHookResult = ReturnType<typeof useAgentsWithConfigurationLazyQuery>;
export type AgentsWithConfigurationQueryResult = Apollo.QueryResult<AgentsWithConfigurationQuery, AgentsWithConfigurationQueryVariables>;
export const SnapshotDocument = gql`
    query snapshot($agentID: String!, $pipelineType: PipelineType!, $position: String, $resourceName: String, $searchQuery: String, $uuid: String!) {
  snapshot(
    agentID: $agentID
    pipelineType: $pipelineType
    position: $position
    resourceName: $resourceName
    searchQuery: $searchQuery
    uuid: $uuid
  ) {
    metrics {
      name
      timestamp
      value
      unit
      type
      attributes
      resource
    }
    logs {
      timestamp
      body
      severity
      attributes
      resource
    }
    traces {
      name
      traceID
      spanID
      parentSpanID
      start
      end
      attributes
      resource
    }
  }
}
    `;

/**
 * __useSnapshotQuery__
 *
 * To run a query within a React component, call `useSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotQuery({
 *   variables: {
 *      agentID: // value for 'agentID'
 *      pipelineType: // value for 'pipelineType'
 *      position: // value for 'position'
 *      resourceName: // value for 'resourceName'
 *      searchQuery: // value for 'searchQuery'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSnapshotQuery(baseOptions: Apollo.QueryHookOptions<SnapshotQuery, SnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotQuery, SnapshotQueryVariables>(SnapshotDocument, options);
      }
export function useSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotQuery, SnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotQuery, SnapshotQueryVariables>(SnapshotDocument, options);
        }
export type SnapshotQueryHookResult = ReturnType<typeof useSnapshotQuery>;
export type SnapshotLazyQueryHookResult = ReturnType<typeof useSnapshotLazyQuery>;
export type SnapshotQueryResult = Apollo.QueryResult<SnapshotQuery, SnapshotQueryVariables>;
export const SnapshotSearchSupportedDocument = gql`
    query snapshotSearchSupported($agentID: String!) {
  snapshotSearchSupported(agentID: $agentID)
}
    `;

/**
 * __useSnapshotSearchSupportedQuery__
 *
 * To run a query within a React component, call `useSnapshotSearchSupportedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotSearchSupportedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotSearchSupportedQuery({
 *   variables: {
 *      agentID: // value for 'agentID'
 *   },
 * });
 */
export function useSnapshotSearchSupportedQuery(baseOptions: Apollo.QueryHookOptions<SnapshotSearchSupportedQuery, SnapshotSearchSupportedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotSearchSupportedQuery, SnapshotSearchSupportedQueryVariables>(SnapshotSearchSupportedDocument, options);
      }
export function useSnapshotSearchSupportedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotSearchSupportedQuery, SnapshotSearchSupportedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotSearchSupportedQuery, SnapshotSearchSupportedQueryVariables>(SnapshotSearchSupportedDocument, options);
        }
export type SnapshotSearchSupportedQueryHookResult = ReturnType<typeof useSnapshotSearchSupportedQuery>;
export type SnapshotSearchSupportedLazyQueryHookResult = ReturnType<typeof useSnapshotSearchSupportedLazyQuery>;
export type SnapshotSearchSupportedQueryResult = Apollo.QueryResult<SnapshotSearchSupportedQuery, SnapshotSearchSupportedQueryVariables>;
export const GetConfigurationTableDocument = gql`
    query GetConfigurationTable($selector: String, $query: String, $onlyDeployedConfigurations: Boolean) {
  configurations(
    selector: $selector
    query: $query
    onlyDeployedConfigurations: $onlyDeployedConfigurations
  ) {
    configurations {
      metadata {
        id
        version
        name
        labels
        description
      }
      agentCount
    }
    query
    suggestions {
      query
      label
    }
  }
}
    `;

/**
 * __useGetConfigurationTableQuery__
 *
 * To run a query within a React component, call `useGetConfigurationTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationTableQuery({
 *   variables: {
 *      selector: // value for 'selector'
 *      query: // value for 'query'
 *      onlyDeployedConfigurations: // value for 'onlyDeployedConfigurations'
 *   },
 * });
 */
export function useGetConfigurationTableQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationTableQuery, GetConfigurationTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationTableQuery, GetConfigurationTableQueryVariables>(GetConfigurationTableDocument, options);
      }
export function useGetConfigurationTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationTableQuery, GetConfigurationTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationTableQuery, GetConfigurationTableQueryVariables>(GetConfigurationTableDocument, options);
        }
export type GetConfigurationTableQueryHookResult = ReturnType<typeof useGetConfigurationTableQuery>;
export type GetConfigurationTableLazyQueryHookResult = ReturnType<typeof useGetConfigurationTableLazyQuery>;
export type GetConfigurationTableQueryResult = Apollo.QueryResult<GetConfigurationTableQuery, GetConfigurationTableQueryVariables>;
export const ConfigurationChangesDocument = gql`
    subscription ConfigurationChanges($selector: String, $query: String) {
  configurationChanges(selector: $selector, query: $query) {
    configuration {
      metadata {
        id
        version
        name
        description
        labels
      }
      agentCount
    }
    eventType
  }
}
    `;

/**
 * __useConfigurationChangesSubscription__
 *
 * To run a query within a React component, call `useConfigurationChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationChangesSubscription({
 *   variables: {
 *      selector: // value for 'selector'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConfigurationChangesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ConfigurationChangesSubscription, ConfigurationChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConfigurationChangesSubscription, ConfigurationChangesSubscriptionVariables>(ConfigurationChangesDocument, options);
      }
export type ConfigurationChangesSubscriptionHookResult = ReturnType<typeof useConfigurationChangesSubscription>;
export type ConfigurationChangesSubscriptionResult = Apollo.SubscriptionResult<ConfigurationChangesSubscription>;
export const ConfigurationTableMetricsDocument = gql`
    subscription ConfigurationTableMetrics($period: String!) {
  overviewMetrics(period: $period) {
    metrics {
      name
      nodeID
      pipelineType
      value
      unit
    }
  }
}
    `;

/**
 * __useConfigurationTableMetricsSubscription__
 *
 * To run a query within a React component, call `useConfigurationTableMetricsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationTableMetricsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationTableMetricsSubscription({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useConfigurationTableMetricsSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConfigurationTableMetricsSubscription, ConfigurationTableMetricsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConfigurationTableMetricsSubscription, ConfigurationTableMetricsSubscriptionVariables>(ConfigurationTableMetricsDocument, options);
      }
export type ConfigurationTableMetricsSubscriptionHookResult = ReturnType<typeof useConfigurationTableMetricsSubscription>;
export type ConfigurationTableMetricsSubscriptionResult = Apollo.SubscriptionResult<ConfigurationTableMetricsSubscription>;
export const DestinationsSummaryMetricsDocument = gql`
    query DestinationsSummaryMetrics($names: [String!]!) {
  destinationsSummaryForTelemetryTypes(
    names: $names
    period: "24h"
    interval: "24h"
  ) {
    destinationName
    totalEgress
  }
}
    `;

/**
 * __useDestinationsSummaryMetricsQuery__
 *
 * To run a query within a React component, call `useDestinationsSummaryMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsSummaryMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsSummaryMetricsQuery({
 *   variables: {
 *      names: // value for 'names'
 *   },
 * });
 */
export function useDestinationsSummaryMetricsQuery(baseOptions: Apollo.QueryHookOptions<DestinationsSummaryMetricsQuery, DestinationsSummaryMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsSummaryMetricsQuery, DestinationsSummaryMetricsQueryVariables>(DestinationsSummaryMetricsDocument, options);
      }
export function useDestinationsSummaryMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsSummaryMetricsQuery, DestinationsSummaryMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsSummaryMetricsQuery, DestinationsSummaryMetricsQueryVariables>(DestinationsSummaryMetricsDocument, options);
        }
export type DestinationsSummaryMetricsQueryHookResult = ReturnType<typeof useDestinationsSummaryMetricsQuery>;
export type DestinationsSummaryMetricsLazyQueryHookResult = ReturnType<typeof useDestinationsSummaryMetricsLazyQuery>;
export type DestinationsSummaryMetricsQueryResult = Apollo.QueryResult<DestinationsSummaryMetricsQuery, DestinationsSummaryMetricsQueryVariables>;
export const GetDestinationTypeDisplayInfoDocument = gql`
    query getDestinationTypeDisplayInfo($name: String!) {
  destinationType(name: $name) {
    metadata {
      id
      name
      version
      displayName
      icon
    }
  }
}
    `;

/**
 * __useGetDestinationTypeDisplayInfoQuery__
 *
 * To run a query within a React component, call `useGetDestinationTypeDisplayInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationTypeDisplayInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationTypeDisplayInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetDestinationTypeDisplayInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationTypeDisplayInfoQuery, GetDestinationTypeDisplayInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationTypeDisplayInfoQuery, GetDestinationTypeDisplayInfoQueryVariables>(GetDestinationTypeDisplayInfoDocument, options);
      }
export function useGetDestinationTypeDisplayInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationTypeDisplayInfoQuery, GetDestinationTypeDisplayInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationTypeDisplayInfoQuery, GetDestinationTypeDisplayInfoQueryVariables>(GetDestinationTypeDisplayInfoDocument, options);
        }
export type GetDestinationTypeDisplayInfoQueryHookResult = ReturnType<typeof useGetDestinationTypeDisplayInfoQuery>;
export type GetDestinationTypeDisplayInfoLazyQueryHookResult = ReturnType<typeof useGetDestinationTypeDisplayInfoLazyQuery>;
export type GetDestinationTypeDisplayInfoQueryResult = Apollo.QueryResult<GetDestinationTypeDisplayInfoQuery, GetDestinationTypeDisplayInfoQueryVariables>;
export const GetSourceTypeDisplayInfoDocument = gql`
    query getSourceTypeDisplayInfo($name: String!) {
  sourceType(name: $name) {
    metadata {
      id
      name
      version
      displayName
      icon
    }
  }
}
    `;

/**
 * __useGetSourceTypeDisplayInfoQuery__
 *
 * To run a query within a React component, call `useGetSourceTypeDisplayInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceTypeDisplayInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceTypeDisplayInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSourceTypeDisplayInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSourceTypeDisplayInfoQuery, GetSourceTypeDisplayInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourceTypeDisplayInfoQuery, GetSourceTypeDisplayInfoQueryVariables>(GetSourceTypeDisplayInfoDocument, options);
      }
export function useGetSourceTypeDisplayInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourceTypeDisplayInfoQuery, GetSourceTypeDisplayInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourceTypeDisplayInfoQuery, GetSourceTypeDisplayInfoQueryVariables>(GetSourceTypeDisplayInfoDocument, options);
        }
export type GetSourceTypeDisplayInfoQueryHookResult = ReturnType<typeof useGetSourceTypeDisplayInfoQuery>;
export type GetSourceTypeDisplayInfoLazyQueryHookResult = ReturnType<typeof useGetSourceTypeDisplayInfoLazyQuery>;
export type GetSourceTypeDisplayInfoQueryResult = Apollo.QueryResult<GetSourceTypeDisplayInfoQuery, GetSourceTypeDisplayInfoQueryVariables>;
export const GetProcessorWithTypeDocument = gql`
    query getProcessorWithType($name: String!) {
  processorWithType(name: $name) {
    processor {
      metadata {
        name
        version
        id
        labels
        version
      }
      spec {
        type
        parameters {
          name
          value
        }
        disabled
      }
    }
    processorType {
      metadata {
        id
        name
        version
        icon
        description
        additionalInfo {
          message
          documentation {
            text
            url
          }
        }
        resourceDocLink
      }
      spec {
        parameters {
          label
          name
          description
          required
          type
          default
          relevantIf {
            name
            operator
            value
          }
          documentation {
            text
            url
          }
          advancedConfig
          validValues
          options {
            multiline
            creatable
            trackUnchecked
            sectionHeader
            subHeader
            horizontalDivider
            gridColumns
            labels
            metricCategories {
              label
              column
              metrics {
                name
                description
                kpi
              }
            }
            password
            sensitive
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProcessorWithTypeQuery__
 *
 * To run a query within a React component, call `useGetProcessorWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessorWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessorWithTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetProcessorWithTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProcessorWithTypeQuery, GetProcessorWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessorWithTypeQuery, GetProcessorWithTypeQueryVariables>(GetProcessorWithTypeDocument, options);
      }
export function useGetProcessorWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessorWithTypeQuery, GetProcessorWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessorWithTypeQuery, GetProcessorWithTypeQueryVariables>(GetProcessorWithTypeDocument, options);
        }
export type GetProcessorWithTypeQueryHookResult = ReturnType<typeof useGetProcessorWithTypeQuery>;
export type GetProcessorWithTypeLazyQueryHookResult = ReturnType<typeof useGetProcessorWithTypeLazyQuery>;
export type GetProcessorWithTypeQueryResult = Apollo.QueryResult<GetProcessorWithTypeQuery, GetProcessorWithTypeQueryVariables>;
export const ProcessorTypeDisplayInfoDocument = gql`
    query ProcessorTypeDisplayInfo($name: String!) {
  processorType(name: $name) {
    metadata {
      id
      displayName
      name
      version
    }
  }
}
    `;

/**
 * __useProcessorTypeDisplayInfoQuery__
 *
 * To run a query within a React component, call `useProcessorTypeDisplayInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorTypeDisplayInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorTypeDisplayInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProcessorTypeDisplayInfoQuery(baseOptions: Apollo.QueryHookOptions<ProcessorTypeDisplayInfoQuery, ProcessorTypeDisplayInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorTypeDisplayInfoQuery, ProcessorTypeDisplayInfoQueryVariables>(ProcessorTypeDisplayInfoDocument, options);
      }
export function useProcessorTypeDisplayInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorTypeDisplayInfoQuery, ProcessorTypeDisplayInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorTypeDisplayInfoQuery, ProcessorTypeDisplayInfoQueryVariables>(ProcessorTypeDisplayInfoDocument, options);
        }
export type ProcessorTypeDisplayInfoQueryHookResult = ReturnType<typeof useProcessorTypeDisplayInfoQuery>;
export type ProcessorTypeDisplayInfoLazyQueryHookResult = ReturnType<typeof useProcessorTypeDisplayInfoLazyQuery>;
export type ProcessorTypeDisplayInfoQueryResult = Apollo.QueryResult<ProcessorTypeDisplayInfoQuery, ProcessorTypeDisplayInfoQueryVariables>;
export const ConfigurationCountDocument = gql`
    query ConfigurationCount($query: String!) {
  configurationCount(query: $query)
}
    `;

/**
 * __useConfigurationCountQuery__
 *
 * To run a query within a React component, call `useConfigurationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConfigurationCountQuery(baseOptions: Apollo.QueryHookOptions<ConfigurationCountQuery, ConfigurationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationCountQuery, ConfigurationCountQueryVariables>(ConfigurationCountDocument, options);
      }
export function useConfigurationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationCountQuery, ConfigurationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationCountQuery, ConfigurationCountQueryVariables>(ConfigurationCountDocument, options);
        }
export type ConfigurationCountQueryHookResult = ReturnType<typeof useConfigurationCountQuery>;
export type ConfigurationCountLazyQueryHookResult = ReturnType<typeof useConfigurationCountLazyQuery>;
export type ConfigurationCountQueryResult = Apollo.QueryResult<ConfigurationCountQuery, ConfigurationCountQueryVariables>;
export const SourcesSummaryDocument = gql`
    query SourcesSummary($names: [String!]!) {
  sourcesSummary(names: $names, period: "24h", interval: "24h") {
    sourceName
    totalIngest
  }
}
    `;

/**
 * __useSourcesSummaryQuery__
 *
 * To run a query within a React component, call `useSourcesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcesSummaryQuery({
 *   variables: {
 *      names: // value for 'names'
 *   },
 * });
 */
export function useSourcesSummaryQuery(baseOptions: Apollo.QueryHookOptions<SourcesSummaryQuery, SourcesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcesSummaryQuery, SourcesSummaryQueryVariables>(SourcesSummaryDocument, options);
      }
export function useSourcesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcesSummaryQuery, SourcesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcesSummaryQuery, SourcesSummaryQueryVariables>(SourcesSummaryDocument, options);
        }
export type SourcesSummaryQueryHookResult = ReturnType<typeof useSourcesSummaryQuery>;
export type SourcesSummaryLazyQueryHookResult = ReturnType<typeof useSourcesSummaryLazyQuery>;
export type SourcesSummaryQueryResult = Apollo.QueryResult<SourcesSummaryQuery, SourcesSummaryQueryVariables>;
export const ClearAgentUpgradeErrorDocument = gql`
    mutation ClearAgentUpgradeError($input: ClearAgentUpgradeErrorInput!) {
  clearAgentUpgradeError(input: $input)
}
    `;
export type ClearAgentUpgradeErrorMutationFn = Apollo.MutationFunction<ClearAgentUpgradeErrorMutation, ClearAgentUpgradeErrorMutationVariables>;

/**
 * __useClearAgentUpgradeErrorMutation__
 *
 * To run a mutation, you first call `useClearAgentUpgradeErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAgentUpgradeErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAgentUpgradeErrorMutation, { data, loading, error }] = useClearAgentUpgradeErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearAgentUpgradeErrorMutation(baseOptions?: Apollo.MutationHookOptions<ClearAgentUpgradeErrorMutation, ClearAgentUpgradeErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAgentUpgradeErrorMutation, ClearAgentUpgradeErrorMutationVariables>(ClearAgentUpgradeErrorDocument, options);
      }
export type ClearAgentUpgradeErrorMutationHookResult = ReturnType<typeof useClearAgentUpgradeErrorMutation>;
export type ClearAgentUpgradeErrorMutationResult = Apollo.MutationResult<ClearAgentUpgradeErrorMutation>;
export type ClearAgentUpgradeErrorMutationOptions = Apollo.BaseMutationOptions<ClearAgentUpgradeErrorMutation, ClearAgentUpgradeErrorMutationVariables>;
export const SnapshotProcessedDocument = gql`
    query snapshotProcessed($agentID: String!, $pipelineType: PipelineType!, $position: String, $resourceName: String, $processorsJSON: String, $searchQuery: String, $uuid: String!) {
  snapshotProcessed(
    agentID: $agentID
    pipelineType: $pipelineType
    position: $position
    resourceName: $resourceName
    processorsJSON: $processorsJSON
    searchQuery: $searchQuery
    uuid: $uuid
  ) {
    metrics {
      name
      timestamp
      value
      unit
      type
      attributes
      resource
    }
    logs {
      timestamp
      body
      severity
      attributes
      resource
    }
    traces {
      name
      traceID
      spanID
      parentSpanID
      start
      end
      attributes
      resource
    }
    processedMetrics {
      name
      timestamp
      value
      unit
      type
      attributes
      resource
    }
    processedLogs {
      timestamp
      body
      severity
      attributes
      resource
    }
    processedTraces {
      name
      traceID
      spanID
      parentSpanID
      start
      end
      attributes
      resource
    }
  }
}
    `;

/**
 * __useSnapshotProcessedQuery__
 *
 * To run a query within a React component, call `useSnapshotProcessedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotProcessedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotProcessedQuery({
 *   variables: {
 *      agentID: // value for 'agentID'
 *      pipelineType: // value for 'pipelineType'
 *      position: // value for 'position'
 *      resourceName: // value for 'resourceName'
 *      processorsJSON: // value for 'processorsJSON'
 *      searchQuery: // value for 'searchQuery'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSnapshotProcessedQuery(baseOptions: Apollo.QueryHookOptions<SnapshotProcessedQuery, SnapshotProcessedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotProcessedQuery, SnapshotProcessedQueryVariables>(SnapshotProcessedDocument, options);
      }
export function useSnapshotProcessedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotProcessedQuery, SnapshotProcessedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotProcessedQuery, SnapshotProcessedQueryVariables>(SnapshotProcessedDocument, options);
        }
export type SnapshotProcessedQueryHookResult = ReturnType<typeof useSnapshotProcessedQuery>;
export type SnapshotProcessedLazyQueryHookResult = ReturnType<typeof useSnapshotProcessedLazyQuery>;
export type SnapshotProcessedQueryResult = Apollo.QueryResult<SnapshotProcessedQuery, SnapshotProcessedQueryVariables>;
export const GetUserRoleDocument = gql`
    query GetUserRole {
  user {
    metadata {
      name
      id
      version
    }
    role
  }
}
    `;

/**
 * __useGetUserRoleQuery__
 *
 * To run a query within a React component, call `useGetUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRoleQuery, GetUserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRoleQuery, GetUserRoleQueryVariables>(GetUserRoleDocument, options);
      }
export function useGetUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRoleQuery, GetUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRoleQuery, GetUserRoleQueryVariables>(GetUserRoleDocument, options);
        }
export type GetUserRoleQueryHookResult = ReturnType<typeof useGetUserRoleQuery>;
export type GetUserRoleLazyQueryHookResult = ReturnType<typeof useGetUserRoleLazyQuery>;
export type GetUserRoleQueryResult = Apollo.QueryResult<GetUserRoleQuery, GetUserRoleQueryVariables>;
export const GetResourceTypeDocument = gql`
    query GetResourceType($kind: Kind!, $name: String!) {
  resourceType(kind: $kind, name: $name) {
    metadata {
      displayName
      name
      version
      id
      description
      deprecated
      additionalInfo {
        message
        documentation {
          text
          url
        }
      }
      resourceDocLink
    }
    spec {
      parameters {
        label
        name
        description
        required
        type
        default
        relevantIf {
          name
          operator
          value
        }
        documentation {
          text
          url
        }
        advancedConfig
        options {
          creatable
          trackUnchecked
          gridColumns
          sectionHeader
          subHeader
          horizontalDivider
          multiline
          labels
          metricCategories {
            label
            column
            metrics {
              name
              description
              kpi
            }
          }
          password
          sensitive
          ottlContext
        }
        documentation {
          text
          url
        }
        validValues
      }
    }
  }
}
    `;

/**
 * __useGetResourceTypeQuery__
 *
 * To run a query within a React component, call `useGetResourceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceTypeQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetResourceTypeQuery(baseOptions: Apollo.QueryHookOptions<GetResourceTypeQuery, GetResourceTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceTypeQuery, GetResourceTypeQueryVariables>(GetResourceTypeDocument, options);
      }
export function useGetResourceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceTypeQuery, GetResourceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceTypeQuery, GetResourceTypeQueryVariables>(GetResourceTypeDocument, options);
        }
export type GetResourceTypeQueryHookResult = ReturnType<typeof useGetResourceTypeQuery>;
export type GetResourceTypeLazyQueryHookResult = ReturnType<typeof useGetResourceTypeLazyQuery>;
export type GetResourceTypeQueryResult = Apollo.QueryResult<GetResourceTypeQuery, GetResourceTypeQueryVariables>;
export const GetResourceTypesDocument = gql`
    query GetResourceTypes($kind: Kind!) {
  resourceTypes(kind: $kind) {
    metadata {
      displayName
      description
      name
      labels
      version
      id
      deprecated
      additionalInfo {
        message
        documentation {
          text
          url
        }
      }
      resourceDocLink
    }
    spec {
      parameters {
        label
        name
        description
        required
        type
        default
        relevantIf {
          name
          operator
          value
        }
        documentation {
          text
          url
        }
        advancedConfig
        validValues
        options {
          creatable
          trackUnchecked
          gridColumns
          sectionHeader
          subHeader
          horizontalDivider
          multiline
          labels
          metricCategories {
            label
            column
            metrics {
              name
              description
              kpi
            }
          }
          password
          sensitive
          ottlContext
        }
        documentation {
          text
          url
        }
      }
      telemetryTypes
    }
  }
}
    `;

/**
 * __useGetResourceTypesQuery__
 *
 * To run a query within a React component, call `useGetResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceTypesQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGetResourceTypesQuery(baseOptions: Apollo.QueryHookOptions<GetResourceTypesQuery, GetResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceTypesQuery, GetResourceTypesQueryVariables>(GetResourceTypesDocument, options);
      }
export function useGetResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceTypesQuery, GetResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceTypesQuery, GetResourceTypesQueryVariables>(GetResourceTypesDocument, options);
        }
export type GetResourceTypesQueryHookResult = ReturnType<typeof useGetResourceTypesQuery>;
export type GetResourceTypesLazyQueryHookResult = ReturnType<typeof useGetResourceTypesLazyQuery>;
export type GetResourceTypesQueryResult = Apollo.QueryResult<GetResourceTypesQuery, GetResourceTypesQueryVariables>;
export const GetResourceWithTypeDocument = gql`
    query GetResourceWithType($kind: Kind!, $name: String!) {
  resourceWithType(kind: $kind, name: $name) {
    resource {
      metadata {
        name
        version
        id
        labels
        version
      }
      spec {
        type
        parameters {
          name
          value
        }
        disabled
      }
    }
    resourceType {
      metadata {
        id
        name
        version
        description
        displayName
        deprecated
        additionalInfo {
          message
          documentation {
            text
            url
          }
        }
        resourceDocLink
      }
      spec {
        parameters {
          label
          name
          description
          required
          type
          default
          relevantIf {
            name
            operator
            value
          }
          documentation {
            text
            url
          }
          advancedConfig
          validValues
          options {
            multiline
            creatable
            trackUnchecked
            sectionHeader
            subHeader
            horizontalDivider
            gridColumns
            labels
            metricCategories {
              label
              column
              metrics {
                name
                description
                kpi
              }
            }
            password
            sensitive
            ottlContext
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetResourceWithTypeQuery__
 *
 * To run a query within a React component, call `useGetResourceWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceWithTypeQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetResourceWithTypeQuery(baseOptions: Apollo.QueryHookOptions<GetResourceWithTypeQuery, GetResourceWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceWithTypeQuery, GetResourceWithTypeQueryVariables>(GetResourceWithTypeDocument, options);
      }
export function useGetResourceWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceWithTypeQuery, GetResourceWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceWithTypeQuery, GetResourceWithTypeQueryVariables>(GetResourceWithTypeDocument, options);
        }
export type GetResourceWithTypeQueryHookResult = ReturnType<typeof useGetResourceWithTypeQuery>;
export type GetResourceWithTypeLazyQueryHookResult = ReturnType<typeof useGetResourceWithTypeLazyQuery>;
export type GetResourceWithTypeQueryResult = Apollo.QueryResult<GetResourceWithTypeQuery, GetResourceWithTypeQueryVariables>;
export const FindApiKeyDocument = gql`
    query findApiKey {
  findApiKey {
    id
    createdAt
  }
}
    `;

/**
 * __useFindApiKeyQuery__
 *
 * To run a query within a React component, call `useFindApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindApiKeyQuery(baseOptions?: Apollo.QueryHookOptions<FindApiKeyQuery, FindApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindApiKeyQuery, FindApiKeyQueryVariables>(FindApiKeyDocument, options);
      }
export function useFindApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindApiKeyQuery, FindApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindApiKeyQuery, FindApiKeyQueryVariables>(FindApiKeyDocument, options);
        }
export type FindApiKeyQueryHookResult = ReturnType<typeof useFindApiKeyQuery>;
export type FindApiKeyLazyQueryHookResult = ReturnType<typeof useFindApiKeyLazyQuery>;
export type FindApiKeyQueryResult = Apollo.QueryResult<FindApiKeyQuery, FindApiKeyQueryVariables>;
export const NewApiKeyDocument = gql`
    mutation newApiKey {
  createAPIKey {
    key
    configureCommand
  }
}
    `;
export type NewApiKeyMutationFn = Apollo.MutationFunction<NewApiKeyMutation, NewApiKeyMutationVariables>;

/**
 * __useNewApiKeyMutation__
 *
 * To run a mutation, you first call `useNewApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newApiKeyMutation, { data, loading, error }] = useNewApiKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useNewApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<NewApiKeyMutation, NewApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewApiKeyMutation, NewApiKeyMutationVariables>(NewApiKeyDocument, options);
      }
export type NewApiKeyMutationHookResult = ReturnType<typeof useNewApiKeyMutation>;
export type NewApiKeyMutationResult = Apollo.MutationResult<NewApiKeyMutation>;
export type NewApiKeyMutationOptions = Apollo.BaseMutationOptions<NewApiKeyMutation, NewApiKeyMutationVariables>;
export const GetAccountPageInfoDocument = gql`
    query getAccountPageInfo {
  user {
    metadata {
      id
      name
      version
      displayName
    }
    spec {
      activeAccount
      email
    }
    role
  }
  users {
    metadata {
      id
      name
      version
      displayName
    }
    spec {
      activeAccount
      email
    }
    role
  }
  accounts {
    metadata {
      id
      name
      version
      displayName
    }
  }
}
    `;

/**
 * __useGetAccountPageInfoQuery__
 *
 * To run a query within a React component, call `useGetAccountPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPageInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountPageInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountPageInfoQuery, GetAccountPageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountPageInfoQuery, GetAccountPageInfoQueryVariables>(GetAccountPageInfoDocument, options);
      }
export function useGetAccountPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountPageInfoQuery, GetAccountPageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountPageInfoQuery, GetAccountPageInfoQueryVariables>(GetAccountPageInfoDocument, options);
        }
export type GetAccountPageInfoQueryHookResult = ReturnType<typeof useGetAccountPageInfoQuery>;
export type GetAccountPageInfoLazyQueryHookResult = ReturnType<typeof useGetAccountPageInfoLazyQuery>;
export type GetAccountPageInfoQueryResult = Apollo.QueryResult<GetAccountPageInfoQuery, GetAccountPageInfoQueryVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($input: RemoveUserInput!) {
  removeUser(input: $input) {
    metadata {
      name
      id
      version
      displayName
    }
    spec {
      activeAccount
      email
    }
    role
  }
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const UsersDocument = gql`
    subscription Users {
  users {
    metadata {
      name
      id
      version
      displayName
    }
    spec {
      email
      activeAccount
    }
    role
  }
}
    `;

/**
 * __useUsersSubscription__
 *
 * To run a query within a React component, call `useUsersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUsersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUsersSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UsersSubscription, UsersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UsersSubscription, UsersSubscriptionVariables>(UsersDocument, options);
      }
export type UsersSubscriptionHookResult = ReturnType<typeof useUsersSubscription>;
export type UsersSubscriptionResult = Apollo.SubscriptionResult<UsersSubscription>;
export const GetInvitationsDocument = gql`
    query getInvitations {
  invitations {
    id
    accountId
    email
    createdAt
    expiredAt
    redeemedAt
    createdBy
    redeemedBy
    role
    note
    status
    link
  }
}
    `;

/**
 * __useGetInvitationsQuery__
 *
 * To run a query within a React component, call `useGetInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
      }
export function useGetInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
export type GetInvitationsQueryHookResult = ReturnType<typeof useGetInvitationsQuery>;
export type GetInvitationsLazyQueryHookResult = ReturnType<typeof useGetInvitationsLazyQuery>;
export type GetInvitationsQueryResult = Apollo.QueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const InvitationsDocument = gql`
    subscription invitations {
  invitations {
    id
  }
}
    `;

/**
 * __useInvitationsSubscription__
 *
 * To run a query within a React component, call `useInvitationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInvitationsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<InvitationsSubscription, InvitationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InvitationsSubscription, InvitationsSubscriptionVariables>(InvitationsDocument, options);
      }
export type InvitationsSubscriptionHookResult = ReturnType<typeof useInvitationsSubscription>;
export type InvitationsSubscriptionResult = Apollo.SubscriptionResult<InvitationsSubscription>;
export const GetAgentHealthDocument = gql`
    query GetAgentHealth($id: ID!, $interval: String!) {
  agentHealthMetrics(id: $id, interval: $interval) {
    name
    timestamp
    value
    unit
    type
    attributes
    resource
  }
}
    `;

/**
 * __useGetAgentHealthQuery__
 *
 * To run a query within a React component, call `useGetAgentHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentHealthQuery({
 *   variables: {
 *      id: // value for 'id'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetAgentHealthQuery(baseOptions: Apollo.QueryHookOptions<GetAgentHealthQuery, GetAgentHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentHealthQuery, GetAgentHealthQueryVariables>(GetAgentHealthDocument, options);
      }
export function useGetAgentHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentHealthQuery, GetAgentHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentHealthQuery, GetAgentHealthQueryVariables>(GetAgentHealthDocument, options);
        }
export type GetAgentHealthQueryHookResult = ReturnType<typeof useGetAgentHealthQuery>;
export type GetAgentHealthLazyQueryHookResult = ReturnType<typeof useGetAgentHealthLazyQuery>;
export type GetAgentHealthQueryResult = Apollo.QueryResult<GetAgentHealthQuery, GetAgentHealthQueryVariables>;
export const GetConfigurationNamesDocument = gql`
    query GetConfigurationNames {
  configurations {
    configurations {
      metadata {
        id
        name
        version
        labels
      }
    }
  }
}
    `;

/**
 * __useGetConfigurationNamesQuery__
 *
 * To run a query within a React component, call `useGetConfigurationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationNamesQuery, GetConfigurationNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationNamesQuery, GetConfigurationNamesQueryVariables>(GetConfigurationNamesDocument, options);
      }
export function useGetConfigurationNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationNamesQuery, GetConfigurationNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationNamesQuery, GetConfigurationNamesQueryVariables>(GetConfigurationNamesDocument, options);
        }
export type GetConfigurationNamesQueryHookResult = ReturnType<typeof useGetConfigurationNamesQuery>;
export type GetConfigurationNamesLazyQueryHookResult = ReturnType<typeof useGetConfigurationNamesLazyQuery>;
export type GetConfigurationNamesQueryResult = Apollo.QueryResult<GetConfigurationNamesQuery, GetConfigurationNamesQueryVariables>;
export const GetInstalledAgentsDocument = gql`
    query GetInstalledAgents($selector: String!) {
  agents(selector: $selector) {
    agents {
      id
      name
      status
      version
    }
  }
}
    `;

/**
 * __useGetInstalledAgentsQuery__
 *
 * To run a query within a React component, call `useGetInstalledAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledAgentsQuery({
 *   variables: {
 *      selector: // value for 'selector'
 *   },
 * });
 */
export function useGetInstalledAgentsQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledAgentsQuery, GetInstalledAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledAgentsQuery, GetInstalledAgentsQueryVariables>(GetInstalledAgentsDocument, options);
      }
export function useGetInstalledAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledAgentsQuery, GetInstalledAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledAgentsQuery, GetInstalledAgentsQueryVariables>(GetInstalledAgentsDocument, options);
        }
export type GetInstalledAgentsQueryHookResult = ReturnType<typeof useGetInstalledAgentsQuery>;
export type GetInstalledAgentsLazyQueryHookResult = ReturnType<typeof useGetInstalledAgentsLazyQuery>;
export type GetInstalledAgentsQueryResult = Apollo.QueryResult<GetInstalledAgentsQuery, GetInstalledAgentsQueryVariables>;
export const GetAgentDocument = gql`
    query GetAgent($agentId: ID!) {
  agent(id: $agentId) {
    id
    name
    architecture
    operatingSystem
    labels
    hostName
    platform
    version
    macAddress
    remoteAddress
    home
    status
    connectedAt
    disconnectedAt
    errorMessage
    configuration {
      Collector
    }
    configurationResource {
      metadata {
        id
        version
        name
      }
      rendered
    }
    upgrade {
      status
      version
      error
    }
    upgradeAvailable
    features
  }
}
    `;

/**
 * __useGetAgentQuery__
 *
 * To run a query within a React component, call `useGetAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetAgentQuery(baseOptions: Apollo.QueryHookOptions<GetAgentQuery, GetAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
      }
export function useGetAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
        }
export type GetAgentQueryHookResult = ReturnType<typeof useGetAgentQuery>;
export type GetAgentLazyQueryHookResult = ReturnType<typeof useGetAgentLazyQuery>;
export type GetAgentQueryResult = Apollo.QueryResult<GetAgentQuery, GetAgentQueryVariables>;
export const GetAgentPageConfigurationsDocument = gql`
    query GetAgentPageConfigurations {
  configurations {
    configurations {
      metadata {
        id
        name
        version
        labels
      }
      spec {
        raw
      }
    }
  }
}
    `;

/**
 * __useGetAgentPageConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetAgentPageConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPageConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPageConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentPageConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentPageConfigurationsQuery, GetAgentPageConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentPageConfigurationsQuery, GetAgentPageConfigurationsQueryVariables>(GetAgentPageConfigurationsDocument, options);
      }
export function useGetAgentPageConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentPageConfigurationsQuery, GetAgentPageConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentPageConfigurationsQuery, GetAgentPageConfigurationsQueryVariables>(GetAgentPageConfigurationsDocument, options);
        }
export type GetAgentPageConfigurationsQueryHookResult = ReturnType<typeof useGetAgentPageConfigurationsQuery>;
export type GetAgentPageConfigurationsLazyQueryHookResult = ReturnType<typeof useGetAgentPageConfigurationsLazyQuery>;
export type GetAgentPageConfigurationsQueryResult = Apollo.QueryResult<GetAgentPageConfigurationsQuery, GetAgentPageConfigurationsQueryVariables>;
export const AgentDetailsChangedDocument = gql`
    subscription AgentDetailsChanged($agentID: String) {
  agentDetailsChanged(agentID: $agentID)
}
    `;

/**
 * __useAgentDetailsChangedSubscription__
 *
 * To run a query within a React component, call `useAgentDetailsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentDetailsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentDetailsChangedSubscription({
 *   variables: {
 *      agentID: // value for 'agentID'
 *   },
 * });
 */
export function useAgentDetailsChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AgentDetailsChangedSubscription, AgentDetailsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgentDetailsChangedSubscription, AgentDetailsChangedSubscriptionVariables>(AgentDetailsChangedDocument, options);
      }
export type AgentDetailsChangedSubscriptionHookResult = ReturnType<typeof useAgentDetailsChangedSubscription>;
export type AgentDetailsChangedSubscriptionResult = Apollo.SubscriptionResult<AgentDetailsChangedSubscription>;
export const GetUsernamesDocument = gql`
    query getUsernames {
  users {
    metadata {
      id
      name
      version
      displayName
    }
  }
}
    `;

/**
 * __useGetUsernamesQuery__
 *
 * To run a query within a React component, call `useGetUsernamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsernamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsernamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsernamesQuery(baseOptions?: Apollo.QueryHookOptions<GetUsernamesQuery, GetUsernamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsernamesQuery, GetUsernamesQueryVariables>(GetUsernamesDocument, options);
      }
export function useGetUsernamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsernamesQuery, GetUsernamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsernamesQuery, GetUsernamesQueryVariables>(GetUsernamesDocument, options);
        }
export type GetUsernamesQueryHookResult = ReturnType<typeof useGetUsernamesQuery>;
export type GetUsernamesLazyQueryHookResult = ReturnType<typeof useGetUsernamesLazyQuery>;
export type GetUsernamesQueryResult = Apollo.QueryResult<GetUsernamesQuery, GetUsernamesQueryVariables>;
export const GetAuditEventsDocument = gql`
    query GetAuditEvents($options: AuditEventFilter, $sort: String) {
  auditEvents(options: $options, sort: $sort) {
    id
    timestamp
    resourceName
    resourceKind
    configuration
    action
    user
    account
    description
  }
}
    `;

/**
 * __useGetAuditEventsQuery__
 *
 * To run a query within a React component, call `useGetAuditEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditEventsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAuditEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetAuditEventsQuery, GetAuditEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditEventsQuery, GetAuditEventsQueryVariables>(GetAuditEventsDocument, options);
      }
export function useGetAuditEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditEventsQuery, GetAuditEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditEventsQuery, GetAuditEventsQueryVariables>(GetAuditEventsDocument, options);
        }
export type GetAuditEventsQueryHookResult = ReturnType<typeof useGetAuditEventsQuery>;
export type GetAuditEventsLazyQueryHookResult = ReturnType<typeof useGetAuditEventsLazyQuery>;
export type GetAuditEventsQueryResult = Apollo.QueryResult<GetAuditEventsQuery, GetAuditEventsQueryVariables>;
export const GetConfigRolloutAgentsDocument = gql`
    query getConfigRolloutAgents($name: String!) {
  configuration(name: $name) {
    metadata {
      name
      id
      version
    }
    agentCount
  }
}
    `;

/**
 * __useGetConfigRolloutAgentsQuery__
 *
 * To run a query within a React component, call `useGetConfigRolloutAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigRolloutAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigRolloutAgentsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetConfigRolloutAgentsQuery(baseOptions: Apollo.QueryHookOptions<GetConfigRolloutAgentsQuery, GetConfigRolloutAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigRolloutAgentsQuery, GetConfigRolloutAgentsQueryVariables>(GetConfigRolloutAgentsDocument, options);
      }
export function useGetConfigRolloutAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigRolloutAgentsQuery, GetConfigRolloutAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigRolloutAgentsQuery, GetConfigRolloutAgentsQueryVariables>(GetConfigRolloutAgentsDocument, options);
        }
export type GetConfigRolloutAgentsQueryHookResult = ReturnType<typeof useGetConfigRolloutAgentsQuery>;
export type GetConfigRolloutAgentsLazyQueryHookResult = ReturnType<typeof useGetConfigRolloutAgentsLazyQuery>;
export type GetConfigRolloutAgentsQueryResult = Apollo.QueryResult<GetConfigRolloutAgentsQuery, GetConfigRolloutAgentsQueryVariables>;
export const GetRenderedConfigValueDocument = gql`
    query getRenderedConfigValue($name: String!) {
  configuration(name: $name) {
    metadata {
      name
      id
      version
    }
    rendered
  }
}
    `;

/**
 * __useGetRenderedConfigValueQuery__
 *
 * To run a query within a React component, call `useGetRenderedConfigValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderedConfigValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderedConfigValueQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRenderedConfigValueQuery(baseOptions: Apollo.QueryHookOptions<GetRenderedConfigValueQuery, GetRenderedConfigValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderedConfigValueQuery, GetRenderedConfigValueQueryVariables>(GetRenderedConfigValueDocument, options);
      }
export function useGetRenderedConfigValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderedConfigValueQuery, GetRenderedConfigValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderedConfigValueQuery, GetRenderedConfigValueQueryVariables>(GetRenderedConfigValueDocument, options);
        }
export type GetRenderedConfigValueQueryHookResult = ReturnType<typeof useGetRenderedConfigValueQuery>;
export type GetRenderedConfigValueLazyQueryHookResult = ReturnType<typeof useGetRenderedConfigValueLazyQuery>;
export type GetRenderedConfigValueQueryResult = Apollo.QueryResult<GetRenderedConfigValueQuery, GetRenderedConfigValueQueryVariables>;
export const GetConfigurationDocument = gql`
    query GetConfiguration($name: String!) {
  configuration(name: $name) {
    metadata {
      id
      name
      description
      labels
      version
    }
    agentCount
    spec {
      measurementInterval
      raw
      sources {
        id
        type
        name
        displayName
        parameters {
          name
          value
        }
        processors {
          id
          type
          name
          displayName
          parameters {
            name
            value
          }
          disabled
        }
        disabled
      }
      destinations {
        id
        type
        name
        displayName
        parameters {
          name
          value
        }
        processors {
          id
          type
          name
          displayName
          parameters {
            name
            value
          }
          disabled
        }
        disabled
      }
      extensions {
        id
        type
        name
        displayName
        disabled
        parameters {
          name
          value
        }
      }
      selector {
        matchLabels
      }
    }
    graph {
      attributes
      sources {
        id
        type
        label
        attributes
      }
      intermediates {
        id
        type
        label
        attributes
      }
      targets {
        id
        type
        label
        attributes
      }
      edges {
        id
        source
        target
      }
    }
  }
}
    `;

/**
 * __useGetConfigurationQuery__
 *
 * To run a query within a React component, call `useGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
      }
export function useGetConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
        }
export type GetConfigurationQueryHookResult = ReturnType<typeof useGetConfigurationQuery>;
export type GetConfigurationLazyQueryHookResult = ReturnType<typeof useGetConfigurationLazyQuery>;
export type GetConfigurationQueryResult = Apollo.QueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export const DestinationsAndTypesDocument = gql`
    query DestinationsAndTypes {
  destinationTypes {
    kind
    apiVersion
    metadata {
      id
      version
      name
      displayName
      deprecated
      description
      icon
      version
      additionalInfo {
        message
        documentation {
          text
          url
        }
      }
      resourceDocLink
    }
    spec {
      version
      parameters {
        label
        type
        name
        description
        default
        validValues
        relevantIf {
          name
          value
          operator
        }
        documentation {
          text
          url
        }
        advancedConfig
        required
        options {
          creatable
          multiline
          trackUnchecked
          sectionHeader
          subHeader
          horizontalDivider
          gridColumns
          labels
          metricCategories {
            label
            column
            metrics {
              name
              description
              kpi
            }
          }
          password
          sensitive
          subHeader
          horizontalDivider
        }
      }
      supportedPlatforms
      telemetryTypes
    }
  }
  destinations {
    metadata {
      id
      version
      name
    }
    spec {
      type
      parameters {
        name
        value
      }
      disabled
    }
  }
}
    `;

/**
 * __useDestinationsAndTypesQuery__
 *
 * To run a query within a React component, call `useDestinationsAndTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsAndTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsAndTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDestinationsAndTypesQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsAndTypesQuery, DestinationsAndTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsAndTypesQuery, DestinationsAndTypesQueryVariables>(DestinationsAndTypesDocument, options);
      }
export function useDestinationsAndTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsAndTypesQuery, DestinationsAndTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsAndTypesQuery, DestinationsAndTypesQueryVariables>(DestinationsAndTypesDocument, options);
        }
export type DestinationsAndTypesQueryHookResult = ReturnType<typeof useDestinationsAndTypesQuery>;
export type DestinationsAndTypesLazyQueryHookResult = ReturnType<typeof useDestinationsAndTypesLazyQuery>;
export type DestinationsAndTypesQueryResult = Apollo.QueryResult<DestinationsAndTypesQuery, DestinationsAndTypesQueryVariables>;
export const SourcesAndTypesDocument = gql`
    query sourcesAndTypes {
  sourceTypes {
    apiVersion
    kind
    metadata {
      id
      name
      version
      displayName
      description
      icon
      additionalInfo {
        message
        documentation {
          text
          url
        }
      }
      resourceDocLink
    }
    spec {
      parameters {
        name
        label
        description
        relevantIf {
          name
          operator
          value
        }
        documentation {
          text
          url
        }
        advancedConfig
        required
        type
        validValues
        default
        options {
          creatable
          multiline
          trackUnchecked
          sectionHeader
          subHeader
          horizontalDivider
          gridColumns
          labels
          metricCategories {
            label
            column
            metrics {
              name
              description
              kpi
            }
          }
          password
          sensitive
        }
      }
      supportedPlatforms
      version
      telemetryTypes
    }
  }
  sources {
    metadata {
      id
      version
      name
    }
    spec {
      type
      parameters {
        name
        value
      }
      disabled
    }
  }
}
    `;

/**
 * __useSourcesAndTypesQuery__
 *
 * To run a query within a React component, call `useSourcesAndTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcesAndTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcesAndTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSourcesAndTypesQuery(baseOptions?: Apollo.QueryHookOptions<SourcesAndTypesQuery, SourcesAndTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcesAndTypesQuery, SourcesAndTypesQueryVariables>(SourcesAndTypesDocument, options);
      }
export function useSourcesAndTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcesAndTypesQuery, SourcesAndTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcesAndTypesQuery, SourcesAndTypesQueryVariables>(SourcesAndTypesDocument, options);
        }
export type SourcesAndTypesQueryHookResult = ReturnType<typeof useSourcesAndTypesQuery>;
export type SourcesAndTypesLazyQueryHookResult = ReturnType<typeof useSourcesAndTypesLazyQuery>;
export type SourcesAndTypesQueryResult = Apollo.QueryResult<SourcesAndTypesQuery, SourcesAndTypesQueryVariables>;
export const GetConfigNamesDocument = gql`
    query getConfigNames {
  configurations {
    configurations {
      metadata {
        id
        name
        version
      }
    }
  }
}
    `;

/**
 * __useGetConfigNamesQuery__
 *
 * To run a query within a React component, call `useGetConfigNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigNamesQuery, GetConfigNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigNamesQuery, GetConfigNamesQueryVariables>(GetConfigNamesDocument, options);
      }
export function useGetConfigNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigNamesQuery, GetConfigNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigNamesQuery, GetConfigNamesQueryVariables>(GetConfigNamesDocument, options);
        }
export type GetConfigNamesQueryHookResult = ReturnType<typeof useGetConfigNamesQuery>;
export type GetConfigNamesLazyQueryHookResult = ReturnType<typeof useGetConfigNamesLazyQuery>;
export type GetConfigNamesQueryResult = Apollo.QueryResult<GetConfigNamesQuery, GetConfigNamesQueryVariables>;
export const DestinationsDocument = gql`
    query Destinations($query: String, $filterUnused: Boolean) {
  destinations(query: $query, filterUnused: $filterUnused) {
    kind
    metadata {
      id
      name
      version
    }
    spec {
      type
    }
  }
}
    `;

/**
 * __useDestinationsQuery__
 *
 * To run a query within a React component, call `useDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      filterUnused: // value for 'filterUnused'
 *   },
 * });
 */
export function useDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
      }
export function useDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
        }
export type DestinationsQueryHookResult = ReturnType<typeof useDestinationsQuery>;
export type DestinationsLazyQueryHookResult = ReturnType<typeof useDestinationsLazyQuery>;
export type DestinationsQueryResult = Apollo.QueryResult<DestinationsQuery, DestinationsQueryVariables>;
export const GetOverviewPageDocument = gql`
    query getOverviewPage($configIDs: [ID!], $destinationIDs: [ID!]) {
  overviewPage(configIDs: $configIDs, destinationIDs: $destinationIDs) {
    graph {
      attributes
      sources {
        id
        label
        type
        attributes
      }
      intermediates {
        id
        label
        type
        attributes
      }
      targets {
        id
        label
        type
        attributes
      }
      edges {
        id
        source
        target
      }
    }
  }
}
    `;

/**
 * __useGetOverviewPageQuery__
 *
 * To run a query within a React component, call `useGetOverviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewPageQuery({
 *   variables: {
 *      configIDs: // value for 'configIDs'
 *      destinationIDs: // value for 'destinationIDs'
 *   },
 * });
 */
export function useGetOverviewPageQuery(baseOptions?: Apollo.QueryHookOptions<GetOverviewPageQuery, GetOverviewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverviewPageQuery, GetOverviewPageQueryVariables>(GetOverviewPageDocument, options);
      }
export function useGetOverviewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverviewPageQuery, GetOverviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverviewPageQuery, GetOverviewPageQueryVariables>(GetOverviewPageDocument, options);
        }
export type GetOverviewPageQueryHookResult = ReturnType<typeof useGetOverviewPageQuery>;
export type GetOverviewPageLazyQueryHookResult = ReturnType<typeof useGetOverviewPageLazyQuery>;
export type GetOverviewPageQueryResult = Apollo.QueryResult<GetOverviewPageQuery, GetOverviewPageQueryVariables>;
export const DeployedConfigsDocument = gql`
    query DeployedConfigs {
  configurations(onlyDeployedConfigurations: true) {
    configurations {
      metadata {
        id
        name
        version
      }
    }
  }
}
    `;

/**
 * __useDeployedConfigsQuery__
 *
 * To run a query within a React component, call `useDeployedConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeployedConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeployedConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeployedConfigsQuery(baseOptions?: Apollo.QueryHookOptions<DeployedConfigsQuery, DeployedConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeployedConfigsQuery, DeployedConfigsQueryVariables>(DeployedConfigsDocument, options);
      }
export function useDeployedConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeployedConfigsQuery, DeployedConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeployedConfigsQuery, DeployedConfigsQueryVariables>(DeployedConfigsDocument, options);
        }
export type DeployedConfigsQueryHookResult = ReturnType<typeof useDeployedConfigsQuery>;
export type DeployedConfigsLazyQueryHookResult = ReturnType<typeof useDeployedConfigsLazyQuery>;
export type DeployedConfigsQueryResult = Apollo.QueryResult<DeployedConfigsQuery, DeployedConfigsQueryVariables>;
export const OverviewPageMetricsDocument = gql`
    subscription OverviewPageMetrics($period: String!, $configIDs: [ID!], $destinationIDs: [ID!]) {
  overviewMetrics(
    period: $period
    configIDs: $configIDs
    destinationIDs: $destinationIDs
  ) {
    metrics {
      name
      nodeID
      pipelineType
      value
      unit
    }
    edgeMetrics {
      name
      edgeID
      unit
      value
      pipelineType
    }
    maxMetricValue
    maxLogValue
    maxTraceValue
  }
}
    `;

/**
 * __useOverviewPageMetricsSubscription__
 *
 * To run a query within a React component, call `useOverviewPageMetricsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOverviewPageMetricsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewPageMetricsSubscription({
 *   variables: {
 *      period: // value for 'period'
 *      configIDs: // value for 'configIDs'
 *      destinationIDs: // value for 'destinationIDs'
 *   },
 * });
 */
export function useOverviewPageMetricsSubscription(baseOptions: Apollo.SubscriptionHookOptions<OverviewPageMetricsSubscription, OverviewPageMetricsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OverviewPageMetricsSubscription, OverviewPageMetricsSubscriptionVariables>(OverviewPageMetricsDocument, options);
      }
export type OverviewPageMetricsSubscriptionHookResult = ReturnType<typeof useOverviewPageMetricsSubscription>;
export type OverviewPageMetricsSubscriptionResult = Apollo.SubscriptionResult<OverviewPageMetricsSubscription>;
export const GetDestinationsSummaryDataDocument = gql`
    query GetDestinationsSummaryData($period: String!, $interval: String!, $telemetryType: String!) {
  destinationsSummary(
    period: $period
    interval: $interval
    telemetryType: $telemetryType
  ) {
    totalEgress
    destinationName
  }
}
    `;

/**
 * __useGetDestinationsSummaryDataQuery__
 *
 * To run a query within a React component, call `useGetDestinationsSummaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationsSummaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationsSummaryDataQuery({
 *   variables: {
 *      period: // value for 'period'
 *      interval: // value for 'interval'
 *      telemetryType: // value for 'telemetryType'
 *   },
 * });
 */
export function useGetDestinationsSummaryDataQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationsSummaryDataQuery, GetDestinationsSummaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationsSummaryDataQuery, GetDestinationsSummaryDataQueryVariables>(GetDestinationsSummaryDataDocument, options);
      }
export function useGetDestinationsSummaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationsSummaryDataQuery, GetDestinationsSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationsSummaryDataQuery, GetDestinationsSummaryDataQueryVariables>(GetDestinationsSummaryDataDocument, options);
        }
export type GetDestinationsSummaryDataQueryHookResult = ReturnType<typeof useGetDestinationsSummaryDataQuery>;
export type GetDestinationsSummaryDataLazyQueryHookResult = ReturnType<typeof useGetDestinationsSummaryDataLazyQuery>;
export type GetDestinationsSummaryDataQueryResult = Apollo.QueryResult<GetDestinationsSummaryDataQuery, GetDestinationsSummaryDataQueryVariables>;
export const GetConfigurationMetricsDocument = gql`
    query GetConfigurationMetrics {
  configurationMetrics(period: "1h") {
    metrics {
      name
      nodeID
      pipelineType
      value
      unit
    }
  }
}
    `;

/**
 * __useGetConfigurationMetricsQuery__
 *
 * To run a query within a React component, call `useGetConfigurationMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationMetricsQuery, GetConfigurationMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationMetricsQuery, GetConfigurationMetricsQueryVariables>(GetConfigurationMetricsDocument, options);
      }
export function useGetConfigurationMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationMetricsQuery, GetConfigurationMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationMetricsQuery, GetConfigurationMetricsQueryVariables>(GetConfigurationMetricsDocument, options);
        }
export type GetConfigurationMetricsQueryHookResult = ReturnType<typeof useGetConfigurationMetricsQuery>;
export type GetConfigurationMetricsLazyQueryHookResult = ReturnType<typeof useGetConfigurationMetricsLazyQuery>;
export type GetConfigurationMetricsQueryResult = Apollo.QueryResult<GetConfigurationMetricsQuery, GetConfigurationMetricsQueryVariables>;
export const SourcesDocument = gql`
    query Sources {
  sources {
    metadata {
      id
      name
      displayName
      version
    }
    spec {
      type
    }
  }
}
    `;

/**
 * __useSourcesQuery__
 *
 * To run a query within a React component, call `useSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSourcesQuery(baseOptions?: Apollo.QueryHookOptions<SourcesQuery, SourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcesQuery, SourcesQueryVariables>(SourcesDocument, options);
      }
export function useSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcesQuery, SourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcesQuery, SourcesQueryVariables>(SourcesDocument, options);
        }
export type SourcesQueryHookResult = ReturnType<typeof useSourcesQuery>;
export type SourcesLazyQueryHookResult = ReturnType<typeof useSourcesLazyQuery>;
export type SourcesQueryResult = Apollo.QueryResult<SourcesQuery, SourcesQueryVariables>;
export const ProcessorsDocument = gql`
    query Processors {
  processors {
    metadata {
      id
      name
      displayName
      version
    }
    spec {
      type
    }
  }
}
    `;

/**
 * __useProcessorsQuery__
 *
 * To run a query within a React component, call `useProcessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessorsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorsQuery, ProcessorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorsQuery, ProcessorsQueryVariables>(ProcessorsDocument, options);
      }
export function useProcessorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorsQuery, ProcessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorsQuery, ProcessorsQueryVariables>(ProcessorsDocument, options);
        }
export type ProcessorsQueryHookResult = ReturnType<typeof useProcessorsQuery>;
export type ProcessorsLazyQueryHookResult = ReturnType<typeof useProcessorsLazyQuery>;
export type ProcessorsQueryResult = Apollo.QueryResult<ProcessorsQuery, ProcessorsQueryVariables>;